var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/icons/close-icon.tsx
import * as React from "react";
var CloseIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    sizeInPixels = 16,
    color = "#2396DC"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 20 20",
      color,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#close-icon_svg__a)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.917 10.15a.209.209 0 0 1 0-.296l7.719-7.718a1.25 1.25 0 0 0-1.77-1.768l-7.718 7.715a.21.21 0 0 1-.296 0L2.134.368A1.25 1.25 0 1 0 .366 2.136l7.717 7.718a.208.208 0 0 1 0 .295L.366 17.87a1.251 1.251 0 0 0 1.768 1.767l7.718-7.72a.208.208 0 0 1 .296 0l7.718 7.72a1.25 1.25 0 0 0 1.768-1.768l-7.717-7.719Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "close-icon_svg__a" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })))
  );
};
var close_icon_default = CloseIcon;

// src/icons/star-icon.tsx
import * as React2 from "react";
var StarIcon = (_a) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return /* @__PURE__ */ React2.createElement(
    "svg",
    __spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React2.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React2.createElement(
      "path",
      {
        fill: "#263340",
        d: "M15.44 5.914c-.14-.375-.501-.625-.905-.626h-3.919c-.137 0-.258-.085-.304-.213L8.905 1.122C8.72.627 8.162.376 7.663.561c-.262.097-.469.302-.567.561l-.003.01L5.69 5.076c-.046.128-.167.213-.304.213h-3.92c-.533 0-.966.428-.966.957 0 .284.127.553.346.735l3.338 2.745c.102.084.142.221.1.346L2.88 14.24c-.168.502.105 1.044.611 1.211.297.099.624.048.877-.136l3.441-2.502c.114-.082.268-.082.38 0l3.441 2.502c.43.313 1.034.222 1.35-.204.187-.25.238-.575.139-.87l-1.402-4.171c-.042-.125-.003-.263.1-.347l3.343-2.748c.308-.26.42-.684.279-1.06z"
      }
    )
  );
};
var star_icon_default = StarIcon;

// src/icons/qr-code-icon.tsx
import * as React3 from "react";
var QrCodeIcon = (_a) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return /* @__PURE__ */ React3.createElement(
    "svg",
    __spreadValues({
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React3.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React3.createElement("g", { clipPath: "url(#clip0_4869_22836)" }, /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M0.916667 7.33333H6.41667C6.65978 7.33333 6.89294 7.23676 7.06485 7.06485C7.23676 6.89294 7.33333 6.65978 7.33333 6.41667V0.916667C7.33333 0.673551 7.23676 0.440394 7.06485 0.268485C6.89294 0.0965771 6.65978 0 6.41667 0L0.916667 0C0.673551 0 0.440394 0.0965771 0.268485 0.268485C0.0965771 0.440394 0 0.673551 0 0.916667L0 6.41667C0 6.65978 0.0965771 6.89294 0.268485 7.06485C0.440394 7.23676 0.673551 7.33333 0.916667 7.33333ZM1.83333 2.0625C1.83333 2.00172 1.85748 1.94343 1.90045 1.90045C1.94343 1.85748 2.00172 1.83333 2.0625 1.83333H5.27083C5.33161 1.83333 5.3899 1.85748 5.43288 1.90045C5.47586 1.94343 5.5 2.00172 5.5 2.0625V5.27083C5.5 5.33161 5.47586 5.3899 5.43288 5.43288C5.3899 5.47586 5.33161 5.5 5.27083 5.5H2.0625C2.00172 5.5 1.94343 5.47586 1.90045 5.43288C1.85748 5.3899 1.83333 5.33161 1.83333 5.27083V2.0625Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M6.41667 14.6666H0.916667C0.673551 14.6666 0.440394 14.7632 0.268485 14.9351C0.0965771 15.107 0 15.3402 0 15.5833L0 21.0833C0 21.3264 0.0965771 21.5596 0.268485 21.7315C0.440394 21.9034 0.673551 22 0.916667 22H6.41667C6.65978 22 6.89294 21.9034 7.06485 21.7315C7.23676 21.5596 7.33333 21.3264 7.33333 21.0833V15.5833C7.33333 15.3402 7.23676 15.107 7.06485 14.9351C6.89294 14.7632 6.65978 14.6666 6.41667 14.6666ZM5.5 19.9375C5.5 19.9982 5.47586 20.0565 5.43288 20.0995C5.3899 20.1425 5.33161 20.1666 5.27083 20.1666H2.0625C2.00172 20.1666 1.94343 20.1425 1.90045 20.0995C1.85748 20.0565 1.83333 19.9982 1.83333 19.9375V16.7291C1.83333 16.6683 1.85748 16.6101 1.90045 16.5671C1.94343 16.5241 2.00172 16.5 2.0625 16.5H5.27083C5.33161 16.5 5.3899 16.5241 5.43288 16.5671C5.47586 16.6101 5.5 16.6683 5.5 16.7291V19.9375Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M21.0833 0H15.5833C15.3402 0 15.1071 0.0965771 14.9352 0.268485C14.7632 0.440394 14.6667 0.673551 14.6667 0.916667V6.41667C14.6667 6.65978 14.7632 6.89294 14.9352 7.06485C15.1071 7.23676 15.3402 7.33333 15.5833 7.33333H21.0833C21.3265 7.33333 21.5596 7.23676 21.7315 7.06485C21.9034 6.89294 22 6.65978 22 6.41667V0.916667C22 0.673551 21.9034 0.440394 21.7315 0.268485C21.5596 0.0965771 21.3265 0 21.0833 0ZM20.1667 5.27083C20.1667 5.33161 20.1425 5.3899 20.0996 5.43288C20.0566 5.47586 19.9983 5.5 19.9375 5.5H16.7292C16.6684 5.5 16.6101 5.47586 16.5671 5.43288C16.5241 5.3899 16.5 5.33161 16.5 5.27083V2.0625C16.5 2.00172 16.5241 1.94343 16.5671 1.90045C16.6101 1.85748 16.6684 1.83333 16.7292 1.83333H19.9375C19.9983 1.83333 20.0566 1.85748 20.0996 1.90045C20.1425 1.94343 20.1667 2.00172 20.1667 2.0625V5.27083Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M9.16667 3.89579H10.0833C10.2657 3.89579 10.4405 3.82336 10.5695 3.69443C10.6984 3.5655 10.7708 3.39063 10.7708 3.20829C10.7708 3.02596 10.6984 2.85109 10.5695 2.72216C10.4405 2.59323 10.2657 2.52079 10.0833 2.52079C10.0226 2.52079 9.96427 2.49665 9.92129 2.45367C9.87832 2.41069 9.85417 2.3524 9.85417 2.29163V0.916626C9.85417 0.73429 9.78174 0.559421 9.65281 0.43049C9.52388 0.301559 9.34901 0.229126 9.16667 0.229126C8.98434 0.229126 8.80947 0.301559 8.68054 0.43049C8.5516 0.559421 8.47917 0.73429 8.47917 0.916626V3.20829C8.47917 3.39063 8.5516 3.5655 8.68054 3.69443C8.80947 3.82336 8.98434 3.89579 9.16667 3.89579Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M11.9167 1.60413C11.9775 1.60413 12.0357 1.62827 12.0787 1.67125C12.1217 1.71422 12.1458 1.77251 12.1458 1.83329V6.87496C12.1458 7.0573 12.2183 7.23216 12.3472 7.36109C12.4761 7.49003 12.651 7.56246 12.8333 7.56246C13.0157 7.56246 13.1905 7.49003 13.3195 7.36109C13.4484 7.23216 13.5208 7.0573 13.5208 6.87496V0.916626C13.5208 0.73429 13.4484 0.559421 13.3195 0.43049C13.1905 0.301559 13.0157 0.229126 12.8333 0.229126H11.9167C11.7343 0.229126 11.5595 0.301559 11.4305 0.43049C11.3016 0.559421 11.2292 0.73429 11.2292 0.916626C11.2292 1.09896 11.3016 1.27383 11.4305 1.40276C11.5595 1.53169 11.7343 1.60413 11.9167 1.60413Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M5.27083 9.62504C5.27083 9.80738 5.34326 9.98225 5.47219 10.1112C5.60112 10.2401 5.77599 10.3125 5.95833 10.3125H9.16666C9.349 10.3125 9.52387 10.2401 9.6528 10.1112C9.78173 9.98225 9.85416 9.80738 9.85416 9.62504V5.95837C9.85416 5.77604 9.78173 5.60117 9.6528 5.47224C9.52387 5.34331 9.349 5.27087 9.16666 5.27087C8.98433 5.27087 8.80946 5.34331 8.68053 5.47224C8.55159 5.60117 8.47916 5.77604 8.47916 5.95837V8.70837C8.47916 8.76915 8.45502 8.82744 8.41204 8.87042C8.36906 8.9134 8.31077 8.93754 8.24999 8.93754H5.95833C5.77599 8.93754 5.60112 9.00997 5.47219 9.13891C5.34326 9.26784 5.27083 9.4427 5.27083 9.62504Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M2.75001 8.9375C2.56767 8.9375 2.3928 9.00993 2.26387 9.13886C2.13494 9.2678 2.06251 9.44266 2.06251 9.625V11.9167C2.06251 11.9774 2.03836 12.0357 1.99538 12.0787C1.95241 12.1217 1.89412 12.1458 1.83334 12.1458H0.916672C0.734335 12.1458 0.559467 12.2183 0.430536 12.3472C0.301605 12.4761 0.229172 12.651 0.229172 12.8333C0.229172 13.0157 0.301605 13.1905 0.430536 13.3195C0.559467 13.4484 0.734335 13.5208 0.916672 13.5208H12.8333C13.0157 13.5208 13.1905 13.4484 13.3195 13.3195C13.4484 13.1905 13.5208 13.0157 13.5208 12.8333V10.0833C13.5208 9.901 13.4484 9.72613 13.3195 9.5972C13.1905 9.46827 13.0157 9.39583 12.8333 9.39583C12.651 9.39583 12.4761 9.46827 12.3472 9.5972C12.2183 9.72613 12.1458 9.901 12.1458 10.0833V11.9167C12.1458 11.9774 12.1217 12.0357 12.0787 12.0787C12.0357 12.1217 11.9775 12.1458 11.9167 12.1458H3.66667C3.60589 12.1458 3.5476 12.1217 3.50463 12.0787C3.46165 12.0357 3.43751 11.9774 3.43751 11.9167V9.625C3.43751 9.44266 3.36507 9.2678 3.23614 9.13886C3.10721 9.00993 2.93234 8.9375 2.75001 8.9375Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M12.6042 15.5834C12.6042 15.401 12.5317 15.2262 12.4028 15.0972C12.2739 14.9683 12.099 14.8959 11.9167 14.8959H9.16667C8.98434 14.8959 8.80947 14.9683 8.68054 15.0972C8.5516 15.2262 8.47917 15.401 8.47917 15.5834V19.25C8.47917 19.4324 8.5516 19.6072 8.68054 19.7362C8.80947 19.8651 8.98434 19.9375 9.16667 19.9375C9.34901 19.9375 9.52388 19.8651 9.65281 19.7362C9.78174 19.6072 9.85417 19.4324 9.85417 19.25V16.5C9.85417 16.4393 9.87832 16.381 9.92129 16.338C9.96427 16.295 10.0226 16.2709 10.0833 16.2709H11.9167C12.099 16.2709 12.2739 16.1984 12.4028 16.0695C12.5317 15.9406 12.6042 15.7657 12.6042 15.5834Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M21.0833 20.3959H13.2917C13.2309 20.3959 13.1726 20.3717 13.1296 20.3288C13.0866 20.2858 13.0625 20.2275 13.0625 20.1667V18.3334C13.0625 18.151 12.9901 17.9762 12.8611 17.8472C12.7322 17.7183 12.5573 17.6459 12.375 17.6459C12.1927 17.6459 12.0178 17.7183 11.8889 17.8472C11.7599 17.9762 11.6875 18.151 11.6875 18.3334V21.0834C11.6875 21.2657 11.7599 21.4406 11.8889 21.5695C12.0178 21.6984 12.1927 21.7709 12.375 21.7709H21.0833C21.2657 21.7709 21.4405 21.6984 21.5695 21.5695C21.6984 21.4406 21.7708 21.2657 21.7708 21.0834C21.7708 20.901 21.6984 20.7262 21.5695 20.5972C21.4405 20.4683 21.2657 20.3959 21.0833 20.3959Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M15.125 18.5625H17.875C18.0573 18.5625 18.2322 18.4901 18.3611 18.3611C18.4901 18.2322 18.5625 18.0573 18.5625 17.875V15.125C18.5625 14.9427 18.4901 14.7678 18.3611 14.6389C18.2322 14.5099 18.0573 14.4375 17.875 14.4375H15.125C14.9427 14.4375 14.7678 14.5099 14.6389 14.6389C14.5099 14.7678 14.4375 14.9427 14.4375 15.125V17.875C14.4375 18.0573 14.5099 18.2322 14.6389 18.3611C14.7678 18.4901 14.9427 18.5625 15.125 18.5625ZM15.8125 16.0417C15.8125 15.9809 15.8366 15.9226 15.8796 15.8796C15.9226 15.8366 15.9809 15.8125 16.0417 15.8125H16.9583C17.0191 15.8125 17.0774 15.8366 17.1204 15.8796C17.1634 15.9226 17.1875 15.9809 17.1875 16.0417V16.9583C17.1875 17.0191 17.1634 17.0774 17.1204 17.1204C17.0774 17.1634 17.0191 17.1875 16.9583 17.1875H16.0417C15.9809 17.1875 15.9226 17.1634 15.8796 17.1204C15.8366 17.0774 15.8125 17.0191 15.8125 16.9583V16.0417Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M20.625 11.6875C20.4427 11.6875 20.2678 11.7599 20.1389 11.8889C20.0099 12.0178 19.9375 12.1927 19.9375 12.375V18.3333C19.9375 18.5157 20.0099 18.6905 20.1389 18.8195C20.2678 18.9484 20.4427 19.0208 20.625 19.0208C20.8073 19.0208 20.9822 18.9484 21.1111 18.8195C21.2401 18.6905 21.3125 18.5157 21.3125 18.3333V12.375C21.3125 12.1927 21.2401 12.0178 21.1111 11.8889C20.9822 11.7599 20.8073 11.6875 20.625 11.6875Z",
        fill: "#57B1E5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M21.3125 9.16663C21.3125 8.98429 21.2401 8.80942 21.1111 8.68049C20.9822 8.55156 20.8073 8.47913 20.625 8.47913H15.5833C15.401 8.47913 15.2261 8.55156 15.0972 8.68049C14.9683 8.80942 14.8958 8.98429 14.8958 9.16663V11.9166C14.8958 12.099 14.9683 12.2738 15.0972 12.4028C15.2261 12.5317 15.401 12.6041 15.5833 12.6041C15.7657 12.6041 15.9405 12.5317 16.0695 12.4028C16.1984 12.2738 16.2708 12.099 16.2708 11.9166V10.0833C16.2708 10.0225 16.295 9.96422 16.3379 9.92125C16.3809 9.87827 16.4392 9.85413 16.5 9.85413H20.625C20.8073 9.85413 20.9822 9.78169 21.1111 9.65276C21.2401 9.52383 21.3125 9.34896 21.3125 9.16663Z",
        fill: "#57B1E5"
      }
    )),
    /* @__PURE__ */ React3.createElement("defs", null, /* @__PURE__ */ React3.createElement("clipPath", { id: "clip0_4869_22836" }, /* @__PURE__ */ React3.createElement("rect", { width: "22", height: "22", fill: "white" })))
  );
};
var qr_code_icon_default = QrCodeIcon;

// src/icons/search-icon.tsx
import React4 from "react";
var SearchIcon = (_a) => {
  var _b = _a, { sizeInPixels = 16, color = "#000" } = _b, props = __objRest(_b, ["sizeInPixels", "color"]);
  var _a2, _b2;
  return /* @__PURE__ */ React4.createElement(
    "svg",
    __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      fill: "none"
    }, props),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        fill: color,
        fillRule: "evenodd",
        d: "m15.364 13.95-3.615-3.615a6.5 6.5 0 1 0-1.414 1.414l3.615 3.615a1 1 0 0 0 1.414-1.414ZM11 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z",
        clipRule: "evenodd"
      }
    )
  );
};
var search_icon_default = SearchIcon;

// src/icons/arrow-right-icon.tsx
import * as React5 from "react";
var ArrowRightIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 7,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2;
  return /* @__PURE__ */ React5.createElement(
    "svg",
    __spreadValues({
      width: "6",
      height: ((_a2 = props.style) == null ? void 0 : _a2.height) || sizeInPixels,
      viewBox: "0 0 6 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React5.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React5.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        d: "M0.978269 0.199081C0.837266 0.301097 0.750026 0.49273 0.75 0.700501L0.75 6.2996C0.750078 6.50725 0.837269 6.69876 0.978173 6.80076C1.11908 6.90276 1.29185 6.89945 1.43032 6.79209L5.03375 3.99255C5.16799 3.88825 5.25 3.70147 5.25 3.50005C5.25 3.29862 5.16799 3.11185 5.03375 3.00755L1.43032 0.208004C1.29191 0.100615 1.11918 0.0972056 0.978269 0.199081Z",
        fill: color
      }
    )
  );
};
var arrow_right_icon_default = ArrowRightIcon;

// src/icons/arrow-line-right-icon.tsx
import * as React6 from "react";
var ArrowLineRightIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React6.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React6.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React6.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "M13 7.99997C13.0002 8.21803 12.954 8.43364 12.8643 8.63241C12.7746 8.83117 12.6436 9.00853 12.48 9.15264L5.04528 15.6933C4.79892 15.9 4.48145 16.0022 4.16076 15.9779C3.84007 15.9536 3.54162 15.8048 3.32921 15.5633C3.11681 15.3218 3.00732 15.0068 3.02415 14.6856C3.04098 14.3644 3.1828 14.0626 3.41929 13.8446L9.92062 8.12531C9.93846 8.10966 9.95276 8.09039 9.96256 8.06878C9.97236 8.04716 9.97742 8.0237 9.97742 7.99997C9.97742 7.97624 9.97236 7.95278 9.96256 7.93117C9.95276 7.90955 9.93846 7.89028 9.92062 7.87464L3.41929 2.1553C3.1828 1.93734 3.04098 1.6355 3.02415 1.31434C3.00732 0.993168 3.11681 0.67816 3.32921 0.436671C3.54162 0.195181 3.84007 0.0463768 4.16076 0.022077C4.48145 -0.00222276 4.79892 0.0999104 5.04528 0.306638L12.4773 6.8453C12.6413 6.98967 12.7728 7.16729 12.8629 7.36638C12.953 7.56546 12.9997 7.78144 13 7.99997Z",
        fill: color
      }
    )
  );
};
var arrow_line_right_icon_default = ArrowLineRightIcon;

// src/icons/arrow-line-left-icon.tsx
import * as React7 from "react";
var ArrowLineLeftIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React7.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React7.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React7.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React7.createElement(
      "path",
      {
        id: "Vector",
        d: "M3 7.99997C2.99973 7.78191 3.04597 7.5663 3.13564 7.36754C3.22531 7.16877 3.35635 6.99141 3.52 6.8473L10.9547 0.306637C11.201 0.0999104 11.5185 -0.00222275 11.8392 0.022077C12.1599 0.0463768 12.4583 0.195181 12.6707 0.43667C12.8831 0.67816 12.9926 0.993168 12.9758 1.31434C12.959 1.6355 12.8172 1.93734 12.5807 2.1553L6.07934 7.87464C6.06149 7.89028 6.04719 7.90955 6.03739 7.93117C6.0276 7.95278 6.02253 7.97624 6.02253 7.99997C6.02253 8.0237 6.0276 8.04716 6.03739 8.06877C6.04719 8.09039 6.06149 8.10966 6.07934 8.1253L12.5807 13.8446C12.7064 13.9501 12.8097 14.0797 12.8847 14.2257C12.9596 14.3717 13.0046 14.5312 13.017 14.6949C13.0294 14.8585 13.009 15.023 12.9569 15.1786C12.9048 15.3342 12.8221 15.4779 12.7138 15.6011C12.6054 15.7243 12.4735 15.8247 12.3257 15.8962C12.178 15.9677 12.0175 16.0089 11.8536 16.0175C11.6897 16.0261 11.5258 16.0019 11.3714 15.9462C11.217 15.8905 11.0753 15.8045 10.9547 15.6933L3.52267 9.15464C3.35861 9.01027 3.22716 8.83265 3.13704 8.63357C3.04692 8.43448 3.00021 8.2185 3 7.99997Z",
        fill: color
      }
    )
  );
};
var arrow_line_left_icon_default = ArrowLineLeftIcon;

// src/icons/empty-list-scan-icon.tsx
import * as React8 from "react";
var EmptyListScanIcon = (_a) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return /* @__PURE__ */ React8.createElement(
    "svg",
    __spreadValues({
      width: "139",
      height: "70",
      viewBox: "0 0 139 70",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React8.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React8.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M132.608 69C132.764 67.1873 132.843 65.3529 132.843 63.5C132.843 28.4299 104.413 0 69.343 0C34.2729 0 5.84302 28.4299 5.84302 63.5C5.84302 65.3529 5.92238 67.1873 6.0779 69H132.608Z",
        fill: "#EEF2F6"
      }
    ),
    /* @__PURE__ */ React8.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 69C0 68.4477 0.447715 68 1 68H137.36C137.912 68 138.36 68.4477 138.36 69C138.36 69.5523 137.912 70 137.36 70H1C0.447715 70 0 69.5523 0 69Z",
        fill: "#CCD6E0"
      }
    ),
    /* @__PURE__ */ React8.createElement("g", { clipPath: "url(#clip0_4889_3087)" }, /* @__PURE__ */ React8.createElement("g", { clipPath: "url(#clip1_4889_3087)" }, /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M70.4925 41.5H76.8675C77.1493 41.5 77.4195 41.3881 77.6188 41.1888C77.818 40.9895 77.93 40.7193 77.93 40.4375V34.0625C77.93 33.7807 77.818 33.5105 77.6188 33.3112C77.4195 33.1119 77.1493 33 76.8675 33H70.4925C70.2107 33 69.9404 33.1119 69.7412 33.3112C69.5419 33.5105 69.43 33.7807 69.43 34.0625V40.4375C69.43 40.7193 69.5419 40.9895 69.7412 41.1888C69.9404 41.3881 70.2107 41.5 70.4925 41.5ZM71.555 35.3906C71.555 35.3202 71.583 35.2526 71.6328 35.2028C71.6826 35.153 71.7502 35.125 71.8206 35.125H75.5394C75.6098 35.125 75.6774 35.153 75.7272 35.2028C75.777 35.2526 75.805 35.3202 75.805 35.3906V39.1094C75.805 39.1798 75.777 39.2474 75.7272 39.2972C75.6774 39.347 75.6098 39.375 75.5394 39.375H71.8206C71.7502 39.375 71.6826 39.347 71.6328 39.2972C71.583 39.2474 71.555 39.1798 71.555 39.1094V35.3906Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M76.8675 50H70.4925C70.2107 50 69.9404 50.1119 69.7412 50.3112C69.5419 50.5105 69.43 50.7807 69.43 51.0625V57.4375C69.43 57.7193 69.5419 57.9895 69.7412 58.1888C69.9404 58.3881 70.2107 58.5 70.4925 58.5H76.8675C77.1493 58.5 77.4195 58.3881 77.6188 58.1888C77.818 57.9895 77.93 57.7193 77.93 57.4375V51.0625C77.93 50.7807 77.818 50.5105 77.6188 50.3112C77.4195 50.1119 77.1493 50 76.8675 50ZM75.805 56.1094C75.805 56.1798 75.777 56.2474 75.7272 56.2972C75.6774 56.347 75.6098 56.375 75.5394 56.375H71.8206C71.7502 56.375 71.6826 56.347 71.6328 56.2972C71.583 56.2474 71.555 56.1798 71.555 56.1094V52.3906C71.555 52.3202 71.583 52.2526 71.6328 52.2028C71.6826 52.153 71.7502 52.125 71.8206 52.125H75.5394C75.6098 52.125 75.6774 52.153 75.7272 52.2028C75.777 52.2526 75.805 52.3202 75.805 52.3906V56.1094Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M93.8675 33H87.4925C87.2107 33 86.9404 33.1119 86.7412 33.3112C86.5419 33.5105 86.43 33.7807 86.43 34.0625V40.4375C86.43 40.7193 86.5419 40.9895 86.7412 41.1888C86.9404 41.3881 87.2107 41.5 87.4925 41.5H93.8675C94.1493 41.5 94.4195 41.3881 94.6188 41.1888C94.8181 40.9895 94.93 40.7193 94.93 40.4375V34.0625C94.93 33.7807 94.8181 33.5105 94.6188 33.3112C94.4195 33.1119 94.1493 33 93.8675 33ZM92.805 39.1094C92.805 39.1798 92.777 39.2474 92.7272 39.2972C92.6774 39.347 92.6098 39.375 92.5394 39.375H88.8206C88.7502 39.375 88.6826 39.347 88.6328 39.2972C88.583 39.2474 88.555 39.1798 88.555 39.1094V35.3906C88.555 35.3202 88.583 35.2526 88.6328 35.2028C88.6826 35.153 88.7502 35.125 88.8206 35.125H92.5394C92.6098 35.125 92.6774 35.153 92.7272 35.2028C92.777 35.2526 92.805 35.3202 92.805 35.3906V39.1094Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M80.055 37.5156H81.1175C81.3288 37.5156 81.5315 37.4317 81.681 37.2822C81.8304 37.1328 81.9144 36.9301 81.9144 36.7187C81.9144 36.5074 81.8304 36.3047 81.681 36.1553C81.5315 36.0058 81.3288 35.9219 81.1175 35.9219C81.047 35.9219 80.9795 35.8939 80.9297 35.8441C80.8799 35.7943 80.8519 35.7267 80.8519 35.6562V34.0625C80.8519 33.8512 80.7679 33.6485 80.6185 33.499C80.469 33.3496 80.2663 33.2656 80.055 33.2656C79.8436 33.2656 79.641 33.3496 79.4915 33.499C79.3421 33.6485 79.2581 33.8512 79.2581 34.0625V36.7187C79.2581 36.9301 79.3421 37.1328 79.4915 37.2822C79.641 37.4317 79.8436 37.5156 80.055 37.5156Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M83.2425 34.8594C83.3129 34.8594 83.3805 34.8874 83.4303 34.9372C83.4801 34.987 83.5081 35.0546 83.5081 35.125V40.9687C83.5081 41.1801 83.5921 41.3828 83.7415 41.5322C83.891 41.6817 84.0936 41.7656 84.305 41.7656C84.5163 41.7656 84.719 41.6817 84.8685 41.5322C85.0179 41.3828 85.1019 41.1801 85.1019 40.9687V34.0625C85.1019 33.8512 85.0179 33.6485 84.8685 33.499C84.719 33.3496 84.5163 33.2656 84.305 33.2656H83.2425C83.0311 33.2656 82.8285 33.3496 82.679 33.499C82.5296 33.6485 82.4456 33.8512 82.4456 34.0625C82.4456 34.2738 82.5296 34.4765 82.679 34.626C82.8285 34.7754 83.0311 34.8594 83.2425 34.8594Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M75.5394 44.1563C75.5394 44.3676 75.6233 44.5703 75.7728 44.7197C75.9222 44.8692 76.1249 44.9531 76.3362 44.9531H80.055C80.2663 44.9531 80.469 44.8692 80.6185 44.7197C80.7679 44.5703 80.8519 44.3676 80.8519 44.1563V39.9063C80.8519 39.6949 80.7679 39.4922 80.6185 39.3428C80.469 39.1933 80.2663 39.1094 80.055 39.1094C79.8436 39.1094 79.641 39.1933 79.4915 39.3428C79.3421 39.4922 79.2581 39.6949 79.2581 39.9063V43.0938C79.2581 43.1642 79.2301 43.2318 79.1803 43.2816C79.1305 43.3314 79.0629 43.3594 78.9925 43.3594H76.3362C76.1249 43.3594 75.9222 43.4433 75.7728 43.5928C75.6233 43.7422 75.5394 43.9449 75.5394 44.1563Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M72.6175 43.3594C72.4061 43.3594 72.2035 43.4433 72.054 43.5928C71.9046 43.7422 71.8206 43.9449 71.8206 44.1562V46.8125C71.8206 46.8829 71.7926 46.9505 71.7428 47.0003C71.693 47.0501 71.6254 47.0781 71.555 47.0781H70.4925C70.2811 47.0781 70.0785 47.1621 69.929 47.3115C69.7796 47.461 69.6956 47.6637 69.6956 47.875C69.6956 48.0863 69.7796 48.289 69.929 48.4385C70.0785 48.5879 70.2811 48.6719 70.4925 48.6719H84.305C84.5163 48.6719 84.719 48.5879 84.8685 48.4385C85.0179 48.289 85.1019 48.0863 85.1019 47.875V44.6875C85.1019 44.4762 85.0179 44.2735 84.8685 44.124C84.719 43.9746 84.5163 43.8906 84.305 43.8906C84.0936 43.8906 83.891 43.9746 83.7415 44.124C83.5921 44.2735 83.5081 44.4762 83.5081 44.6875V46.8125C83.5081 46.8829 83.4801 46.9505 83.4303 47.0003C83.3805 47.0501 83.3129 47.0781 83.2425 47.0781H73.68C73.6095 47.0781 73.542 47.0501 73.4922 47.0003C73.4424 46.9505 73.4144 46.8829 73.4144 46.8125V44.1562C73.4144 43.9449 73.3304 43.7422 73.181 43.5928C73.0315 43.4433 72.8288 43.3594 72.6175 43.3594Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M84.0394 51.0625C84.0394 50.8512 83.9554 50.6485 83.806 50.499C83.6565 50.3496 83.4538 50.2656 83.2425 50.2656H80.055C79.8436 50.2656 79.641 50.3496 79.4915 50.499C79.3421 50.6485 79.2581 50.8512 79.2581 51.0625V55.3125C79.2581 55.5238 79.3421 55.7265 79.4915 55.876C79.641 56.0254 79.8436 56.1094 80.055 56.1094C80.2663 56.1094 80.469 56.0254 80.6185 55.876C80.7679 55.7265 80.8519 55.5238 80.8519 55.3125V52.125C80.8519 52.0546 80.8799 51.987 80.9297 51.9372C80.9795 51.8874 81.047 51.8594 81.1175 51.8594H83.2425C83.4538 51.8594 83.6565 51.7754 83.806 51.626C83.9554 51.4765 84.0394 51.2738 84.0394 51.0625Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M93.8675 56.6406H84.8362C84.7658 56.6406 84.6982 56.6126 84.6484 56.5628C84.5986 56.513 84.5706 56.4454 84.5706 56.375V54.25C84.5706 54.0387 84.4867 53.836 84.3372 53.6865C84.1878 53.5371 83.9851 53.4531 83.7737 53.4531C83.5624 53.4531 83.3597 53.5371 83.2103 53.6865C83.0608 53.836 82.9769 54.0387 82.9769 54.25V57.4375C82.9769 57.6488 83.0608 57.8515 83.2103 58.001C83.3597 58.1504 83.5624 58.2344 83.7737 58.2344H93.8675C94.0788 58.2344 94.2815 58.1504 94.431 58.001C94.5804 57.8515 94.6644 57.6488 94.6644 57.4375C94.6644 57.2262 94.5804 57.0235 94.431 56.874C94.2815 56.7246 94.0788 56.6406 93.8675 56.6406Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M86.9612 54.5156H90.1487C90.3601 54.5156 90.5628 54.4317 90.7122 54.2822C90.8617 54.1328 90.9456 53.9301 90.9456 53.7188V50.5312C90.9456 50.3199 90.8617 50.1172 90.7122 49.9678C90.5628 49.8183 90.3601 49.7344 90.1487 49.7344H86.9612C86.7499 49.7344 86.5472 49.8183 86.3978 49.9678C86.2483 50.1172 86.1644 50.3199 86.1644 50.5312V53.7188C86.1644 53.9301 86.2483 54.1328 86.3978 54.2822C86.5472 54.4317 86.7499 54.5156 86.9612 54.5156ZM87.7581 51.5938C87.7581 51.5233 87.7861 51.4557 87.8359 51.4059C87.8857 51.3561 87.9533 51.3281 88.0237 51.3281H89.0862C89.1567 51.3281 89.2243 51.3561 89.2741 51.4059C89.3239 51.4557 89.3519 51.5233 89.3519 51.5938V52.6562C89.3519 52.7267 89.3239 52.7943 89.2741 52.8441C89.2243 52.8939 89.1567 52.9219 89.0862 52.9219H88.0237C87.9533 52.9219 87.8857 52.8939 87.8359 52.8441C87.7861 52.7943 87.7581 52.7267 87.7581 52.6562V51.5938Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M93.3362 46.5469C93.1249 46.5469 92.9222 46.6308 92.7728 46.7803C92.6233 46.9297 92.5394 47.1324 92.5394 47.3437V54.25C92.5394 54.4613 92.6233 54.664 92.7728 54.8135C92.9222 54.9629 93.1249 55.0469 93.3362 55.0469C93.5476 55.0469 93.7503 54.9629 93.8997 54.8135C94.0492 54.664 94.1331 54.4613 94.1331 54.25V47.3437C94.1331 47.1324 94.0492 46.9297 93.8997 46.7803C93.7503 46.6308 93.5476 46.5469 93.3362 46.5469Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        d: "M94.1331 43.625C94.1331 43.4137 94.0492 43.211 93.8997 43.0615C93.7503 42.9121 93.5476 42.8281 93.3362 42.8281H87.4925C87.2811 42.8281 87.0785 42.9121 86.929 43.0615C86.7796 43.211 86.6956 43.4137 86.6956 43.625V46.8125C86.6956 47.0238 86.7796 47.2265 86.929 47.376C87.0785 47.5254 87.2811 47.6094 87.4925 47.6094C87.7038 47.6094 87.9065 47.5254 88.056 47.376C88.2054 47.2265 88.2894 47.0238 88.2894 46.8125V44.6875C88.2894 44.6171 88.3174 44.5495 88.3672 44.4997C88.417 44.4499 88.4845 44.4219 88.555 44.4219H93.3362C93.5476 44.4219 93.7503 44.3379 93.8997 44.1885C94.0492 44.039 94.1331 43.8363 94.1331 43.625Z",
        fill: "#94A6B8"
      }
    )), /* @__PURE__ */ React8.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.43 24C43.43 21.2386 45.6686 19 48.43 19H80.43C83.1914 19 85.43 21.2386 85.43 24V25.5C85.43 28.2614 83.1914 30.5 80.43 30.5H48.43C45.6686 30.5 43.43 28.2614 43.43 25.5V24ZM54.93 24.75C54.93 25.9926 53.9226 27 52.68 27C51.4374 27 50.43 25.9926 50.43 24.75C50.43 23.5074 51.4374 22.5 52.68 22.5C53.9226 22.5 54.93 23.5074 54.93 24.75ZM59.68 27C60.9226 27 61.93 25.9926 61.93 24.75C61.93 23.5074 60.9226 22.5 59.68 22.5C58.4374 22.5 57.43 23.5074 57.43 24.75C57.43 25.9926 58.4374 27 59.68 27Z",
        fill: "#CCD6E0"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.43 33C45.6686 33 43.43 35.2386 43.43 38V39.5C43.43 42.2614 45.6686 44.5 48.43 44.5H64.43C65.5346 44.5 66.43 43.6046 66.43 42.5V35C66.43 33.8954 65.5346 33 64.43 33H48.43ZM52.68 41C53.9226 41 54.93 39.9926 54.93 38.75C54.93 37.5074 53.9226 36.5 52.68 36.5C51.4374 36.5 50.43 37.5074 50.43 38.75C50.43 39.9926 51.4374 41 52.68 41Z",
        fill: "#CCD6E0"
      }
    ), /* @__PURE__ */ React8.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.43 47C45.6686 47 43.43 49.2386 43.43 52V53.5C43.43 56.2614 45.6686 58.5 48.43 58.5H64.43C65.5346 58.5 66.43 57.6046 66.43 56.5V49C66.43 47.8954 65.5346 47 64.43 47H48.43ZM52.68 55C53.9226 55 54.93 53.9926 54.93 52.75C54.93 51.5074 53.9226 50.5 52.68 50.5C51.4374 50.5 50.43 51.5074 50.43 52.75C50.43 53.9926 51.4374 55 52.68 55Z",
        fill: "#CCD6E0"
      }
    )),
    /* @__PURE__ */ React8.createElement("defs", null, /* @__PURE__ */ React8.createElement("clipPath", { id: "clip0_4889_3087" }, /* @__PURE__ */ React8.createElement("rect", { width: "51.5", height: "42", fill: "white", transform: "translate(43.43 18)" })), /* @__PURE__ */ React8.createElement("clipPath", { id: "clip1_4889_3087" }, /* @__PURE__ */ React8.createElement("rect", { width: "25.5", height: "25.5", fill: "white", transform: "translate(69.43 33)" })))
  );
};
var empty_list_scan_icon_default = EmptyListScanIcon;

// src/icons/assign-icon.tsx
import * as React9 from "react";
var AssignIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React9.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React9.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React9.createElement("g", { clipPath: "url(#clip0_5404_3929)" }, /* @__PURE__ */ React9.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1893 4.30101C13.6665 3.67028 11.991 3.50525 10.3745 3.82679C8.75797 4.14834 7.27311 4.94201 6.10767 6.10745C5.78223 6.43288 5.2546 6.43288 4.92916 6.10745C4.60372 5.78201 4.60372 5.25437 4.92916 4.92894C6.32768 3.53041 8.10951 2.578 10.0493 2.19215C11.9891 1.8063 13.9998 2.00433 15.8271 2.76121C17.6543 3.51809 19.2161 4.79981 20.3149 6.4443C21.4137 8.08879 22.0002 10.0222 22.0002 12C22.0002 13.9778 21.4137 15.9112 20.3149 17.5557C19.2161 19.2002 17.6543 20.4819 15.8271 21.2388C13.9998 21.9957 11.9891 22.1937 10.0493 21.8078C8.10951 21.422 6.32768 20.4696 4.92916 19.0711C4.60372 18.7456 4.60372 18.218 4.92916 17.8925C5.25459 17.5671 5.78223 17.5671 6.10767 17.8926C7.2731 19.058 8.75796 19.8517 10.3745 20.1732C11.991 20.4948 13.6665 20.3297 15.1892 19.699C16.712 19.0683 18.0135 18.0002 18.9291 16.6298C19.8448 15.2593 20.3336 13.6482 20.3336 12C20.3336 10.3518 19.8448 8.74066 18.9291 7.37025C18.0135 5.99984 16.712 4.93174 15.1893 4.30101ZM14.6639 9.66275C14.6639 11.1333 13.4718 12.3255 12.0012 12.3255C10.5306 12.3255 9.33845 11.1333 9.33845 9.66275C9.33845 8.19215 10.5306 7 12.0012 7C13.4718 7 14.6639 8.19215 14.6639 9.66275ZM7.83688 16.4817C7.83065 16.4444 7.83335 16.4061 7.84475 16.37L7.84281 16.369C8.1149 15.4787 8.66564 14.6993 9.41397 14.1455C10.1623 13.5917 11.0686 13.2928 11.9996 13.2928C12.9306 13.2928 13.8369 13.5917 14.5852 14.1455C15.3336 14.6993 15.8843 15.4787 16.1564 16.369C16.1674 16.4052 16.1698 16.4434 16.1634 16.4807C16.157 16.518 16.142 16.5533 16.1195 16.5837C16.097 16.6141 16.0676 16.6388 16.0339 16.6558C16.0001 16.6729 15.9628 16.6817 15.925 16.6818H8.07423C8.03666 16.6817 7.99963 16.6729 7.96603 16.6561C7.93243 16.6393 7.90318 16.6149 7.88058 16.5849C7.85808 16.5545 7.8431 16.5191 7.83688 16.4817ZM6.03472 12.3572C6.21064 12.1568 6.21064 11.8434 6.03472 11.643L2.83432 7.99737C2.53416 7.65546 2 7.88407 2 8.35444L2 15.6458C2 16.1162 2.53416 16.3448 2.83432 16.0029L6.03472 12.3572Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React9.createElement("defs", null, /* @__PURE__ */ React9.createElement("clipPath", { id: "clip0_5404_3929" }, /* @__PURE__ */ React9.createElement("rect", { width: "24", height: "24", fill: "white" })))
  );
};
var assign_icon_default = AssignIcon;

// src/icons/unassign-icon.tsx
import * as React10 from "react";
var UnassignIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React10.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React10.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React10.createElement("g", { clipPath: "url(#clip0_5404_3941)" }, /* @__PURE__ */ React10.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.3745 3.82679C11.991 3.50525 13.6665 3.67028 15.1893 4.30101C16.712 4.93174 18.0135 5.99984 18.9291 7.37025C19.8448 8.74066 20.3336 10.3518 20.3336 12C20.3336 13.6482 19.8448 15.2593 18.9291 16.6298C18.0135 18.0002 16.712 19.0683 15.1893 19.699C13.6665 20.3297 11.991 20.4948 10.3745 20.1732C8.75797 19.8517 7.27311 19.058 6.10768 17.8926C5.78224 17.5671 5.2546 17.5671 4.92917 17.8925C4.60373 18.218 4.60373 18.7456 4.92917 19.0711C6.32769 20.4696 8.10952 21.422 10.0493 21.8078C11.9891 22.1937 13.9998 21.9957 15.8271 21.2388C17.6543 20.4819 19.2161 19.2002 20.3149 17.5557C21.4137 15.9112 22.0002 13.9778 22.0002 12C22.0002 10.0222 21.4137 8.08879 20.3149 6.4443C19.2161 4.79981 17.6543 3.51809 15.8271 2.76121C13.9998 2.00433 11.9891 1.8063 10.0493 2.19215C8.10952 2.578 6.32769 3.53041 4.92917 4.92894C4.60373 5.25437 4.60373 5.78201 4.92917 6.10745C5.25461 6.43288 5.78224 6.43288 6.10768 6.10745C7.27312 4.94201 8.75798 4.14834 10.3745 3.82679ZM12.0012 12.3255C13.4718 12.3255 14.6639 11.1333 14.6639 9.66275C14.6639 8.19215 13.4718 7 12.0012 7C10.5306 7 9.33846 8.19215 9.33846 9.66275C9.33846 11.1333 10.5306 12.3255 12.0012 12.3255ZM7.84476 16.37C7.83336 16.4061 7.83066 16.4444 7.83689 16.4817C7.84311 16.5191 7.85809 16.5545 7.88059 16.5849C7.90319 16.6149 7.93244 16.6393 7.96604 16.6561C7.99964 16.6729 8.03668 16.6817 8.07424 16.6818H15.925C15.9628 16.6817 16.0001 16.6729 16.0339 16.6558C16.0677 16.6388 16.097 16.6141 16.1195 16.5837C16.142 16.5533 16.157 16.518 16.1634 16.4807C16.1699 16.4434 16.1674 16.4052 16.1564 16.369C15.8843 15.4787 15.3336 14.6993 14.5852 14.1455C13.8369 13.5917 12.9306 13.2928 11.9996 13.2928C11.0687 13.2928 10.1623 13.5917 9.41398 14.1455C8.66565 14.6993 8.11491 15.4787 7.84282 16.369L7.84476 16.37Z",
        fill: color
      }
    ), /* @__PURE__ */ React10.createElement(
      "path",
      {
        d: "M4.71248 14.784C4.85414 14.9221 5.04412 14.9994 5.24193 14.9994C5.43973 14.9994 5.62972 14.9221 5.77138 14.784C5.91177 14.6435 5.99064 14.4529 5.99064 14.2542C5.99064 14.0555 5.91177 13.865 5.77138 13.7245L4.18677 12.139C4.16934 12.1216 4.1555 12.1009 4.14606 12.0782C4.13663 12.0554 4.13177 12.031 4.13177 12.0064C4.13177 11.9817 4.13663 11.9573 4.14606 11.9346C4.1555 11.9118 4.16934 11.8911 4.18677 11.8737L5.77138 10.2882C5.8429 10.2191 5.89995 10.1364 5.9392 10.045C5.97845 9.95361 5.99911 9.85529 5.99997 9.7558C6.00084 9.65631 5.98189 9.55764 5.94423 9.46556C5.90658 9.37347 5.85097 9.28981 5.78066 9.21946C5.71035 9.14911 5.62674 9.09347 5.5347 9.0558C5.44267 9.01812 5.34406 8.99916 5.24462 9.00003C5.14519 9.00089 5.04692 9.02156 4.95556 9.06083C4.86419 9.1001 4.78156 9.15718 4.71248 9.22875L3.12712 10.8142C3.10979 10.8317 3.0892 10.8455 3.06651 10.8549C3.04383 10.8644 3.01951 10.8692 2.99494 10.8692C2.97038 10.8692 2.94606 10.8644 2.92338 10.8549C2.90069 10.8455 2.8801 10.8317 2.86277 10.8142L1.27816 9.22875C1.13692 9.09226 0.947756 9.01674 0.751405 9.01844C0.555053 9.02015 0.367228 9.09895 0.228382 9.23788C0.089535 9.3768 0.010777 9.56473 0.00907077 9.76119C0.00736453 9.95765 0.0828467 10.1469 0.219259 10.2882L1.80387 11.8737C1.83872 11.9091 1.85825 11.9567 1.85825 12.0064C1.85825 12.056 1.83872 12.1036 1.80387 12.139L0.219259 13.7245C0.078868 13.865 0 14.0555 0 14.2542C0 14.4529 0.078868 14.6435 0.219259 14.784C0.360737 14.9225 0.550789 15 0.74871 15C0.946631 15 1.13668 14.9225 1.27816 14.784L2.86277 13.1985C2.8801 13.1811 2.90069 13.1672 2.92338 13.1578C2.94606 13.1484 2.97038 13.1435 2.99494 13.1435C3.01951 13.1435 3.04383 13.1484 3.06651 13.1578C3.0892 13.1672 3.10979 13.1811 3.12712 13.1985L4.71248 14.784Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React10.createElement("defs", null, /* @__PURE__ */ React10.createElement("clipPath", { id: "clip0_5404_3941" }, /* @__PURE__ */ React10.createElement("rect", { width: "24", height: "24", fill: "white" })))
  );
};
var unassign_icon_default = UnassignIcon;

// src/icons/circle-check-icon.tsx
import * as React11 from "react";
var CircleCheckIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React11.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React11.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React11.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React11.createElement("g", { clipPath: "url(#clip0_5720_5123)" }, /* @__PURE__ */ React11.createElement(
      "path",
      {
        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87903 15.1539 3.84563 13.6541 2.34587C12.1544 0.846118 10.121 0.00247015 8 0ZM12.618 5.46667L8.05467 11.6593C8.0008 11.7308 7.93322 11.7908 7.85589 11.8359C7.77856 11.881 7.69303 11.9102 7.60429 11.9219C7.51554 11.9336 7.42536 11.9274 7.339 11.9039C7.25265 11.8803 7.17186 11.8398 7.10134 11.7847L3.84267 9.17933C3.7743 9.12462 3.71737 9.05697 3.67514 8.98025C3.63291 8.90353 3.6062 8.81925 3.59654 8.73221C3.57704 8.55642 3.62816 8.38009 3.73867 8.242C3.84918 8.10391 4.01001 8.01538 4.1858 7.99587C4.36158 7.97637 4.53791 8.02749 4.676 8.138L7.39334 10.312L11.5447 4.678C11.5946 4.60301 11.6593 4.53892 11.7348 4.48962C11.8102 4.44032 11.8948 4.40683 11.9836 4.39117C12.0724 4.37551 12.1634 4.37801 12.2511 4.39852C12.3389 4.41902 12.4216 4.4571 12.4942 4.51047C12.5668 4.56383 12.6279 4.63136 12.6737 4.70899C12.7194 4.78661 12.749 4.87271 12.7606 4.96209C12.7722 5.05146 12.7655 5.14226 12.741 5.22898C12.7165 5.31571 12.6746 5.39657 12.618 5.46667Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React11.createElement("defs", null, /* @__PURE__ */ React11.createElement("clipPath", { id: "clip0_5720_5123" }, /* @__PURE__ */ React11.createElement("rect", { width: sizeInPixels, height: sizeInPixels, fill: "white" })))
  );
};
var circle_check_icon_default = CircleCheckIcon;

// src/icons/circle-information-icon.tsx
import * as React12 from "react";
var CircleInformationIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React12.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React12.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React12.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React12.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C15.9952 3.5837 12.4163 0.00477656 8 0ZM8.16667 3.33333C8.71895 3.33333 9.16667 3.78105 9.16667 4.33333C9.16667 4.88562 8.71895 5.33333 8.16667 5.33333C7.61438 5.33333 7.16667 4.88562 7.16667 4.33333C7.16667 3.78105 7.61438 3.33333 8.16667 3.33333ZM7 12.3333H9.66667C10.0349 12.3333 10.3333 12.0349 10.3333 11.6667C10.3333 11.2985 10.0349 11 9.66667 11H9.16667C9.07462 11 9 10.9254 9 10.8333V7.66667C9 6.93029 8.40305 6.33333 7.66667 6.33333H7C6.63181 6.33333 6.33333 6.63181 6.33333 7C6.33333 7.36819 6.63181 7.66667 7 7.66667H7.5C7.59205 7.66667 7.66667 7.74129 7.66667 7.83333V10.8333C7.66667 10.9254 7.59205 11 7.5 11H7C6.63181 11 6.33333 11.2985 6.33333 11.6667C6.33333 12.0349 6.63181 12.3333 7 12.3333Z",
        fill: color
      }
    )
  );
};
var circle_information_icon_default = CircleInformationIcon;

// src/icons/location-icon.tsx
import * as React13 from "react";
var LocationIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    color = "#000",
    sizeInPixels = 16
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "color",
    "sizeInPixels"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React13.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React13.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React13.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React13.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 5.6C2 2.504 4.68286 0 8 0C11.3171 0 14 2.504 14 5.6C14 9.8 8 16 8 16C8 16 2 9.8 2 5.6ZM6.03571 5.6C6.03571 6.704 6.91571 7.6 8 7.6C9.08429 7.6 9.96429 6.704 9.96429 5.6C9.96429 4.496 9.08429 3.6 8 3.6C6.91571 3.6 6.03571 4.496 6.03571 5.6Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React13.createElement(
      "mask",
      {
        id: "mask0_5620_4816",
        style: { maskType: "luminance" },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "3",
        width: "4",
        height: "5"
      },
      /* @__PURE__ */ React13.createElement(
        "path",
        {
          d: "M7.99944 7.60156C6.91516 7.60156 6.03516 6.70556 6.03516 5.60156C6.03516 4.49756 6.91516 3.60156 7.99944 3.60156C9.08373 3.60156 9.96373 4.49756 9.96373 5.60156C9.96373 6.70556 9.08373 7.60156 7.99944 7.60156Z",
          fill: "white"
        }
      )
    ),
    /* @__PURE__ */ React13.createElement("g", { mask: "url(#mask0_5620_4816)" })
  );
};
var location_icon_default = LocationIcon;

// src/icons/circle-line-check-icon.tsx
import * as React14 from "react";
var CircleLineCheckIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React14.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React14.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React14.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        d: "M12.32 4.29938C12.232 4.23447 12.132 4.18755 12.0258 4.16129C11.9196 4.13504 11.8092 4.12997 11.7011 4.14638C11.5929 4.16279 11.489 4.20035 11.3954 4.25691C11.3018 4.31348 11.2202 4.38794 11.1553 4.47605L7.20602 9.83605L4.69468 7.82671C4.52153 7.69407 4.3033 7.63454 4.08677 7.66089C3.87025 7.68724 3.67266 7.79737 3.53637 7.96767C3.40008 8.13797 3.33593 8.35488 3.35767 8.57192C3.37941 8.78895 3.48532 8.98883 3.65268 9.12871L6.84135 11.6794C6.92946 11.7483 7.03043 11.799 7.13835 11.8284C7.24626 11.8579 7.35897 11.8656 7.46988 11.851C7.5808 11.8364 7.68769 11.7998 7.78432 11.7435C7.88095 11.6871 7.96538 11.6121 8.03268 11.5227L12.4994 5.46471C12.5641 5.37644 12.6109 5.27626 12.637 5.16991C12.663 5.06355 12.6678 4.95311 12.6512 4.84488C12.6345 4.73666 12.5967 4.63277 12.5399 4.53917C12.4831 4.44557 12.4083 4.36409 12.32 4.29938Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React14.createElement(
      "path",
      {
        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z",
        fill: color
      }
    )
  );
};
var circle_line_check_icon_default = CircleLineCheckIcon;

// src/icons/circle-dash-icon.tsx
import * as React15 from "react";
var CircleDashIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React15.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React15.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React15.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React15.createElement("g", { clipPath: "url(#clip0_6197_587)" }, /* @__PURE__ */ React15.createElement(
      "path",
      {
        d: "M8.00033 0.166748C6.45104 0.166748 4.93655 0.626165 3.64836 1.4869C2.36018 2.34764 1.35616 3.57104 0.763273 5.00239C0.170386 6.43375 0.0152601 8.00877 0.317511 9.52829C0.619762 11.0478 1.36581 12.4436 2.46133 13.5391C3.55684 14.6346 4.9526 15.3806 6.47212 15.6829C7.99164 15.9852 9.56666 15.83 10.998 15.2371C12.4294 14.6443 13.6528 13.6402 14.5135 12.352C15.3742 11.0639 15.8337 9.54937 15.8337 8.00008C15.8314 5.92326 15.0053 3.93215 13.5368 2.46361C12.0683 0.995074 10.0772 0.169042 8.00033 0.166748ZM8.00033 14.1667C6.78068 14.1667 5.58842 13.8051 4.57431 13.1275C3.56021 12.4499 2.76981 11.4868 2.30307 10.36C1.83633 9.23315 1.71421 7.99324 1.95215 6.79702C2.1901 5.60081 2.77741 4.50201 3.63984 3.63959C4.50226 2.77717 5.60106 2.18985 6.79727 1.95191C7.99349 1.71396 9.2334 1.83608 10.3602 2.30282C11.487 2.76956 12.4501 3.55996 13.1277 4.57407C13.8053 5.58817 14.167 6.78043 14.167 8.00008C14.1652 9.63504 13.515 11.2025 12.3589 12.3586C11.2028 13.5147 9.63529 14.165 8.00033 14.1667Z",
        fill: color
      }
    ), /* @__PURE__ */ React15.createElement(
      "path",
      {
        d: "M4.18197 7.16675C3.96095 7.16675 3.74899 7.25455 3.59271 7.41083C3.43643 7.56711 3.34863 7.77907 3.34863 8.00008C3.34863 8.2211 3.43643 8.43306 3.59271 8.58934C3.74899 8.74562 3.96095 8.83341 4.18197 8.83341H11.818C12.039 8.83341 12.2509 8.74562 12.4072 8.58934C12.5635 8.43306 12.6513 8.2211 12.6513 8.00008C12.6513 7.77907 12.5635 7.56711 12.4072 7.41083C12.2509 7.25455 12.039 7.16675 11.818 7.16675H4.18197Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React15.createElement("defs", null, /* @__PURE__ */ React15.createElement("clipPath", { id: "clip0_6197_587" }, /* @__PURE__ */ React15.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var circle_dash_icon_default = CircleDashIcon;

// src/icons/circle-clock-icon.tsx
import * as React16 from "react";
var CircleClockIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React16.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React16.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React16.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React16.createElement("g", { clipPath: "url(#clip0_6197_94)" }, /* @__PURE__ */ React16.createElement(
      "path",
      {
        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87903 15.1539 3.84563 13.6541 2.34587C12.1544 0.846118 10.121 0.00247015 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.9926 1.46144 6.6994C1.71867 5.40619 2.35361 4.2183 3.28596 3.28595C4.21831 2.3536 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76751 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z",
        fill: color
      }
    ), /* @__PURE__ */ React16.createElement(
      "path",
      {
        d: "M11.4227 10.5401L8.33333 7.70741V4.33341C8.33333 4.1566 8.2631 3.98703 8.13807 3.86201C8.01305 3.73699 7.84348 3.66675 7.66667 3.66675C7.48986 3.66675 7.32029 3.73699 7.19526 3.86201C7.07024 3.98703 7 4.1566 7 4.33341V8.00008C6.9999 8.09259 7.01905 8.1841 7.05624 8.26881C7.09342 8.35351 7.14783 8.42955 7.216 8.49208L10.522 11.5221C10.6531 11.64 10.8252 11.7018 11.0013 11.6941C11.1774 11.6865 11.3436 11.6102 11.464 11.4814C11.5832 11.3511 11.6459 11.1787 11.6381 11.0022C11.6304 10.8257 11.5529 10.6595 11.4227 10.5401Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React16.createElement("defs", null, /* @__PURE__ */ React16.createElement("clipPath", { id: "clip0_6197_94" }, /* @__PURE__ */ React16.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var circle_clock_icon_default = CircleClockIcon;

// src/icons/circle-forbidden-icon.tsx
import * as React17 from "react";
var CircleForbiddenIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React17.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React17.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React17.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React17.createElement("g", { clipPath: "url(#clip0_6197_576)" }, /* @__PURE__ */ React17.createElement(
      "path",
      {
        d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM1.6 8C1.6 4.464 4.464 1.6 8 1.6C9.48 1.6 10.84 2.104 11.92 2.952L2.952 11.92C2.104 10.84 1.6 9.48 1.6 8ZM8 14.4C6.52 14.4 5.16 13.896 4.08 13.048L13.048 4.08C13.896 5.16 14.4 6.52 14.4 8C14.4 11.536 11.536 14.4 8 14.4Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React17.createElement("defs", null, /* @__PURE__ */ React17.createElement("clipPath", { id: "clip0_6197_576" }, /* @__PURE__ */ React17.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var circle_forbidden_icon_default = CircleForbiddenIcon;

// src/icons/circle-check-no-background-icon.tsx
import * as React18 from "react";
var CircleCheckNoBackgroundIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React18.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React18.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React18.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React18.createElement("g", { clipPath: "url(#clip0_6207_624)" }, /* @__PURE__ */ React18.createElement("g", { clipPath: "url(#clip1_6207_624)" }, /* @__PURE__ */ React18.createElement(
      "path",
      {
        d: "M12.32 4.29938C12.232 4.23447 12.132 4.18755 12.0258 4.16129C11.9196 4.13504 11.8092 4.12997 11.7011 4.14638C11.5929 4.16279 11.489 4.20035 11.3954 4.25691C11.3018 4.31348 11.2202 4.38794 11.1553 4.47605L7.20602 9.83605L4.69468 7.82671C4.52153 7.69407 4.3033 7.63454 4.08677 7.66089C3.87025 7.68724 3.67266 7.79737 3.53637 7.96767C3.40008 8.13797 3.33593 8.35488 3.35767 8.57192C3.37941 8.78895 3.48532 8.98883 3.65268 9.12871L6.84135 11.6794C6.92946 11.7483 7.03043 11.799 7.13835 11.8284C7.24626 11.8579 7.35897 11.8656 7.46988 11.851C7.5808 11.8364 7.68769 11.7998 7.78432 11.7435C7.88095 11.6871 7.96538 11.6121 8.03268 11.5227L12.4994 5.46471C12.5641 5.37644 12.6109 5.27626 12.637 5.16991C12.663 5.06355 12.6678 4.95311 12.6512 4.84488C12.6345 4.73666 12.5967 4.63277 12.5399 4.53917C12.4831 4.44557 12.4083 4.36409 12.32 4.29938Z",
        fill: color
      }
    ), /* @__PURE__ */ React18.createElement(
      "path",
      {
        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845885 10.121 0.00229405 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.9926 1.46144 6.6994C1.71867 5.40619 2.35361 4.2183 3.28596 3.28595C4.21831 2.3536 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76751 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z",
        fill: color
      }
    ))),
    /* @__PURE__ */ React18.createElement("defs", null, /* @__PURE__ */ React18.createElement("clipPath", { id: "clip0_6207_624" }, /* @__PURE__ */ React18.createElement("rect", { width: "16", height: "16", fill: "white" })), /* @__PURE__ */ React18.createElement("clipPath", { id: "clip1_6207_624" }, /* @__PURE__ */ React18.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var circle_check_no_background_icon_default = CircleCheckNoBackgroundIcon;

// src/icons/circle-user-icon.tsx
import * as React19 from "react";
var CircleUserIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React19.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React19.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React19.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React19.createElement(
      "path",
      {
        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845885 10.121 0.00229405 8 0ZM12.0893 11.9333C12.0444 12.0048 11.982 12.0637 11.9081 12.1045C11.8342 12.1453 11.7511 12.1667 11.6667 12.1667H4.33334C4.24897 12.1666 4.16599 12.1452 4.09211 12.1045C4.01824 12.0638 3.95587 12.005 3.91082 11.9336C3.86577 11.8623 3.83951 11.7807 3.83447 11.6965C3.82943 11.6123 3.84578 11.5282 3.882 11.452C4.25113 10.6721 4.83411 10.0131 5.56312 9.55164C6.29213 9.09015 7.1372 8.84516 8 8.84516C8.86281 8.84516 9.70787 9.09015 10.4369 9.55164C11.1659 10.0131 11.7489 10.6721 12.118 11.452C12.1543 11.5281 12.1707 11.6122 12.1657 11.6964C12.1607 11.7805 12.1344 11.8621 12.0893 11.9333ZM8 2.9C8.48786 2.9 8.96477 3.04467 9.37041 3.31571C9.77605 3.58675 10.0922 3.97199 10.2789 4.42271C10.4656 4.87344 10.5145 5.3694 10.4193 5.84789C10.3241 6.32638 10.0892 6.76589 9.7442 7.11086C9.39923 7.45583 8.95971 7.69076 8.48123 7.78594C8.00274 7.88111 7.50678 7.83227 7.05605 7.64557C6.60533 7.45887 6.22009 7.14271 5.94905 6.73707C5.678 6.33143 5.53334 5.85453 5.53334 5.36667C5.53334 4.71247 5.79322 4.08506 6.25581 3.62247C6.7184 3.15988 7.3458 2.9 8 2.9Z",
        fill: color
      }
    )
  );
};
var circle_user_icon_default = CircleUserIcon;

// src/icons/circle-x-icon.tsx
import * as React20 from "react";
var CircleXIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React20.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React20.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React20.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React20.createElement(
      "path",
      {
        d: "M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM11.44 11.44C11.128 11.752 10.624 11.752 10.312 11.44L8 9.128L5.688 11.44C5.376 11.752 4.872 11.752 4.56 11.44C4.248 11.128 4.248 10.624 4.56 10.312L6.872 8L4.56 5.688C4.248 5.376 4.248 4.872 4.56 4.56C4.872 4.248 5.376 4.248 5.688 4.56L8 6.872L10.312 4.56C10.624 4.248 11.128 4.248 11.44 4.56C11.752 4.872 11.752 5.376 11.44 5.688L9.128 8L11.44 10.312C11.744 10.616 11.744 11.128 11.44 11.44Z",
        fill: color
      }
    )
  );
};
var circle_x_icon_default = CircleXIcon;

// src/icons/circle-exclamation-icon.tsx
import * as React21 from "react";
var CircleExclamationIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React21.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React21.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React21.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React21.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM6.501 12.53C6.53262 13.349 7.20439 13.9974 8.024 14H8.051C8.44738 13.9933 8.82438 13.8273 9.09698 13.5395C9.36958 13.2516 9.51484 12.8662 9.5 12.47C9.46939 11.6505 8.79702 11.0016 7.977 11H7.95C7.55371 11.007 7.17687 11.1731 6.90433 11.4608C6.63179 11.7486 6.48644 12.1339 6.501 12.53ZM7 3C7 2.44772 7.44772 2 8 2C8.55229 2 9 2.44772 9 3V8.5C9 9.05229 8.55229 9.5 8 9.5C7.44772 9.5 7 9.05229 7 8.5V3Z",
        fill: color
      }
    )
  );
};
var circle_exclamation_icon_default = CircleExclamationIcon;

// src/icons/circle-arrow-right-icon.tsx
import * as React22 from "react";
var CircleArrowRightIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React22.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React22.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React22.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React22.createElement(
      "path",
      {
        d: "M7.94559 6.45978e-05C6.05325 -0.00752123 4.21898 0.653225 2.76617 1.86581C1.31336 3.0784 0.335302 4.76497 0.00441818 6.62818C-0.00349662 6.67636 -0.000753419 6.7257 0.0124547 6.77271C0.0256628 6.81972 0.0490147 6.86326 0.0808665 6.90027C0.112718 6.93728 0.152296 6.96686 0.196813 6.98693C0.24133 7.007 0.289704 7.01706 0.33853 7.01641H5.89815C5.98676 7.01641 6.07175 6.98121 6.13441 6.91856C6.19706 6.8559 6.23226 6.77092 6.23226 6.6823V4.2767C6.23222 4.15078 6.26775 4.02742 6.33476 3.92082C6.40177 3.81421 6.49754 3.72872 6.61103 3.67417C6.72451 3.61963 6.8511 3.59826 6.97621 3.61253C7.10131 3.62679 7.21984 3.67612 7.31813 3.75481L11.9957 7.49687C12.074 7.55947 12.1372 7.63888 12.1806 7.72922C12.224 7.81956 12.2466 7.91851 12.2466 8.01875C12.2466 8.11899 12.224 8.21794 12.1806 8.30828C12.1372 8.39862 12.074 8.47803 11.9957 8.54063L7.31813 12.2827C7.19958 12.3775 7.05228 12.4291 6.90049 12.429C6.72375 12.4275 6.5547 12.3566 6.42972 12.2316C6.30474 12.1066 6.23383 11.9375 6.23226 11.7608V9.3552C6.23226 9.26659 6.19706 9.1816 6.13441 9.11895C6.07175 9.05629 5.98676 9.02109 5.89815 9.02109H0.342539C0.293792 9.0211 0.245624 9.03165 0.201336 9.05202C0.157047 9.07238 0.117687 9.10209 0.0859523 9.13909C0.0542176 9.17609 0.0308591 9.21952 0.017478 9.26639C0.00409684 9.31327 0.00100948 9.36248 0.00842752 9.41066C0.369828 11.4056 1.47351 13.1896 3.09732 14.4036C4.72114 15.6176 6.74453 16.1714 8.76023 15.9536C10.7759 15.7357 12.6343 14.7624 13.9613 13.2296C15.2882 11.6967 15.9853 9.71811 15.9122 7.69199C15.8101 5.63763 14.9299 3.69916 13.4501 2.27045C11.9704 0.841744 10.0023 0.029967 7.94559 6.45978e-05Z",
        fill: color
      }
    )
  );
};
var circle_arrow_right_icon_default = CircleArrowRightIcon;

// src/icons/circle-clipboard-icon.tsx
import * as React23 from "react";
var ClipboardIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React23.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React23.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React23.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React23.createElement("g", null, /* @__PURE__ */ React23.createElement(
      "path",
      {
        d: "M13.6667 1.33344H10.3334C10.3052 1.33333 10.2776 1.32581 10.2533 1.31165C10.2289 1.2975 10.2087 1.27719 10.1947 1.25278C9.96903 0.871207 9.64783 0.555025 9.26275 0.33539C8.87768 0.115754 8.44202 0.000244141 7.99871 0.000244141C7.5554 0.000244141 7.11974 0.115754 6.73466 0.33539C6.34958 0.555025 6.02838 0.871207 5.80271 1.25278C5.78892 1.27681 5.76915 1.29686 5.74532 1.311C5.72149 1.32513 5.69441 1.33286 5.66671 1.33344H2.33337C2.06816 1.33344 1.8138 1.4388 1.62627 1.62634C1.43873 1.81387 1.33337 2.06823 1.33337 2.33344V15.0001C1.33337 15.2653 1.43873 15.5197 1.62627 15.7072C1.8138 15.8948 2.06816 16.0001 2.33337 16.0001H13.6667C13.9319 16.0001 14.1863 15.8948 14.3738 15.7072C14.5613 15.5197 14.6667 15.2653 14.6667 15.0001V2.33344C14.6667 2.06823 14.5613 1.81387 14.3738 1.62634C14.1863 1.4388 13.9319 1.33344 13.6667 1.33344ZM12.6667 10.8401C12.6669 11.2376 12.525 11.622 12.2667 11.9241L10.9874 13.4174C10.8308 13.6001 10.6365 13.7468 10.4178 13.8472C10.1992 13.9477 9.96134 13.9996 9.72071 13.9994H3.66671C3.5783 13.9994 3.49352 13.9643 3.43101 13.9018C3.36849 13.8393 3.33337 13.7545 3.33337 13.6661V3.66678C3.33337 3.57837 3.36849 3.49359 3.43101 3.43107C3.49352 3.36856 3.5783 3.33344 3.66671 3.33344H12.3334C12.4218 3.33344 12.5066 3.36856 12.5691 3.43107C12.6316 3.49359 12.6667 3.57837 12.6667 3.66678V10.8401Z",
        fill: color
      }
    ), /* @__PURE__ */ React23.createElement(
      "path",
      {
        d: "M10.6667 5.49927H5.33337C5.20077 5.49927 5.07359 5.55195 4.97982 5.64571C4.88605 5.73948 4.83337 5.86666 4.83337 5.99927C4.83337 6.13188 4.88605 6.25905 4.97982 6.35282C5.07359 6.44659 5.20077 6.49927 5.33337 6.49927H10.6667C10.7993 6.49927 10.9265 6.44659 11.0203 6.35282C11.114 6.25905 11.1667 6.13188 11.1667 5.99927C11.1667 5.86666 11.114 5.73948 11.0203 5.64571C10.9265 5.55195 10.7993 5.49927 10.6667 5.49927Z",
        fill: color
      }
    ), /* @__PURE__ */ React23.createElement(
      "path",
      {
        d: "M10.6667 7.83276H5.33337C5.20077 7.83276 5.07359 7.88544 4.97982 7.97921C4.88605 8.07298 4.83337 8.20016 4.83337 8.33276C4.83337 8.46537 4.88605 8.59255 4.97982 8.68632C5.07359 8.78009 5.20077 8.83276 5.33337 8.83276H10.6667C10.7993 8.83276 10.9265 8.78009 11.0203 8.68632C11.114 8.59255 11.1667 8.46537 11.1667 8.33276C11.1667 8.20016 11.114 8.07298 11.0203 7.97921C10.9265 7.88544 10.7993 7.83276 10.6667 7.83276Z",
        fill: color
      }
    ), /* @__PURE__ */ React23.createElement(
      "path",
      {
        d: "M8.33337 10.166H5.33337C5.20077 10.166 5.07359 10.2187 4.97982 10.3125C4.88605 10.4062 4.83337 10.5334 4.83337 10.666C4.83337 10.7986 4.88605 10.9258 4.97982 11.0196C5.07359 11.1133 5.20077 11.166 5.33337 11.166H8.33337C8.46598 11.166 8.59316 11.1133 8.68693 11.0196C8.7807 10.9258 8.83337 10.7986 8.83337 10.666C8.83337 10.5334 8.7807 10.4062 8.68693 10.3125C8.59316 10.2187 8.46598 10.166 8.33337 10.166Z",
        fill: color
      }
    ))
  );
};
var circle_clipboard_icon_default = ClipboardIcon;

// src/icons/calendar-icon.tsx
import * as React24 from "react";
var CalendarIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React24.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React24.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React24.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React24.createElement("g", null, /* @__PURE__ */ React24.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3334 2H12.5C12.408 2 12.3334 1.92538 12.3334 1.83333V0.666667C12.3334 0.298477 12.0349 0 11.6667 0C11.2985 0 11 0.298477 11 0.666667V3.83333C11 4.10948 10.7762 4.33333 10.5 4.33333C10.2239 4.33333 10 4.10948 10 3.83333V2.33333C10 2.14924 9.8508 2 9.66671 2H5.50004C5.40825 2 5.33374 1.92579 5.33337 1.834V0.666667C5.33337 0.298477 5.0349 0 4.66671 0C4.29852 0 4.00004 0.298477 4.00004 0.666667V3.83333C4.00004 4.10948 3.77618 4.33333 3.50004 4.33333C3.2239 4.33333 3.00004 4.10948 3.00004 3.83333V2.33333C3.00004 2.14924 2.8508 2 2.66671 2H1.66671C0.930328 2 0.333374 2.59695 0.333374 3.33333V14.6667C0.333374 15.403 0.930328 16 1.66671 16H14.3334C15.0698 16 15.6667 15.403 15.6667 14.6667V3.33333C15.6667 2.59695 15.0698 2 14.3334 2ZM14.3334 14.3333C14.3334 14.5174 14.1841 14.6667 14 14.6667H2.00004C1.81595 14.6667 1.66671 14.5174 1.66671 14.3333V6.33333C1.66671 6.14924 1.81595 6 2.00004 6H14C14.1841 6 14.3334 6.14924 14.3334 6.33333V14.3333ZM4.33337 7H5.00004C5.36823 7 5.66671 7.29848 5.66671 7.66667C5.66671 8.03486 5.36823 8.33333 5.00004 8.33333H4.33337C3.96518 8.33333 3.66671 8.03486 3.66671 7.66667C3.66671 7.29848 3.96518 7 4.33337 7ZM7.66671 7H8.33337C8.70156 7 9.00004 7.29848 9.00004 7.66667C9.00004 8.03486 8.70156 8.33333 8.33337 8.33333H7.66671C7.29852 8.33333 7.00004 8.03486 7.00004 7.66667C7.00004 7.29848 7.29852 7 7.66671 7ZM11.6667 7H11C10.6319 7 10.3334 7.29848 10.3334 7.66667C10.3334 8.03486 10.6319 8.33333 11 8.33333H11.6667C12.0349 8.33333 12.3334 8.03486 12.3334 7.66667C12.3334 7.29848 12.0349 7 11.6667 7ZM4.33337 9.66667H5.00004C5.36823 9.66667 5.66671 9.96514 5.66671 10.3333C5.66671 10.7015 5.36823 11 5.00004 11H4.33337C3.96518 11 3.66671 10.7015 3.66671 10.3333C3.66671 9.96514 3.96518 9.66667 4.33337 9.66667ZM8.33337 9.66667H7.66671C7.29852 9.66667 7.00004 9.96514 7.00004 10.3333C7.00004 10.7015 7.29852 11 7.66671 11H8.33337C8.70156 11 9.00004 10.7015 9.00004 10.3333C9.00004 9.96514 8.70156 9.66667 8.33337 9.66667ZM11 9.66667H11.6667C12.0349 9.66667 12.3334 9.96514 12.3334 10.3333C12.3334 10.7015 12.0349 11 11.6667 11H11C10.6319 11 10.3334 10.7015 10.3334 10.3333C10.3334 9.96514 10.6319 9.66667 11 9.66667ZM5.00004 12.3333H4.33337C3.96518 12.3333 3.66671 12.6318 3.66671 13C3.66671 13.3682 3.96518 13.6667 4.33337 13.6667H5.00004C5.36823 13.6667 5.66671 13.3682 5.66671 13C5.66671 12.6318 5.36823 12.3333 5.00004 12.3333ZM7.66671 12.3333H8.33337C8.70156 12.3333 9.00004 12.6318 9.00004 13C9.00004 13.3682 8.70156 13.6667 8.33337 13.6667H7.66671C7.29852 13.6667 7.00004 13.3682 7.00004 13C7.00004 12.6318 7.29852 12.3333 7.66671 12.3333ZM11.6667 12.3333H11C10.6319 12.3333 10.3334 12.6318 10.3334 13C10.3334 13.3682 10.6319 13.6667 11 13.6667H11.6667C12.0349 13.6667 12.3334 13.3682 12.3334 13C12.3334 12.6318 12.0349 12.3333 11.6667 12.3333Z",
        fill: color
      }
    ))
  );
};
var calendar_icon_default = CalendarIcon;

// src/icons/icon-component.tsx
import React54, { cloneElement } from "react";

// src/icons/trash-line-icon.tsx
import * as React25 from "react";
var TrashLineIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React25.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 -960 960 960",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React25.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React25.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React25.createElement(
      "path",
      {
        fill: color,
        d: "M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
      }
    )
  );
};
var trash_line_icon_default = TrashLineIcon;

// src/icons/circle-plus-icon.tsx
import * as React26 from "react";
var CirclePlusIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React26.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React26.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React26.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React26.createElement(
      "path",
      {
        d: "M10.4166 19.5834C12.312 19.5834 14.1649 19.0213 15.7409 17.9683C17.3168 16.9152 18.5452 15.4185 19.2705 13.6674C19.9958 11.9163 20.1856 9.98939 19.8158 8.13041C19.4461 6.27142 18.5333 4.56384 17.1931 3.22358C15.8528 1.88333 14.1452 0.970607 12.2863 0.600832C10.4273 0.231057 8.50039 0.420839 6.74926 1.14618C4.99814 1.87152 3.50143 3.09984 2.4484 4.67581C1.39537 6.25178 0.833313 8.10462 0.833313 10C0.83618 12.5408 1.84677 14.9767 3.64337 16.7733C5.43998 18.5699 7.87587 19.5805 10.4166 19.5834ZM5.41665 9.16669H9.37498C9.43023 9.16669 9.48322 9.14474 9.52229 9.10567C9.56136 9.0666 9.58331 9.01361 9.58331 8.95836V5.00002C9.58331 4.77901 9.67111 4.56705 9.82739 4.41077C9.98367 4.25449 10.1956 4.16669 10.4166 4.16669C10.6377 4.16669 10.8496 4.25449 11.0059 4.41077C11.1622 4.56705 11.25 4.77901 11.25 5.00002V8.95836C11.25 9.01361 11.2719 9.0666 11.311 9.10567C11.3501 9.14474 11.4031 9.16669 11.4583 9.16669H15.4166C15.6377 9.16669 15.8496 9.25449 16.0059 9.41077C16.1622 9.56705 16.25 9.77901 16.25 10C16.25 10.221 16.1622 10.433 16.0059 10.5893C15.8496 10.7456 15.6377 10.8334 15.4166 10.8334H11.4583C11.4031 10.8334 11.3501 10.8553 11.311 10.8944C11.2719 10.9334 11.25 10.9864 11.25 11.0417V15C11.25 15.221 11.1622 15.433 11.0059 15.5893C10.8496 15.7456 10.6377 15.8334 10.4166 15.8334C10.1956 15.8334 9.98367 15.7456 9.82739 15.5893C9.67111 15.433 9.58331 15.221 9.58331 15V11.0417C9.58331 10.9864 9.56136 10.9334 9.52229 10.8944C9.48322 10.8553 9.43023 10.8334 9.37498 10.8334H5.41665C5.19563 10.8334 4.98367 10.7456 4.82739 10.5893C4.67111 10.433 4.58331 10.221 4.58331 10C4.58331 9.77901 4.67111 9.56705 4.82739 9.41077C4.98367 9.25449 5.19563 9.16669 5.41665 9.16669Z",
        fill: color
      }
    )
  );
};
var circle_plus_icon_default = CirclePlusIcon;

// src/icons/empty-list-search-icon.tsx
import * as React27 from "react";
var EmptyListSearchIcon = (_a) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return /* @__PURE__ */ React27.createElement(
    "svg",
    __spreadValues({
      width: "139",
      height: "70",
      viewBox: "0 0 139 70",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React27.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M132.608 69C132.764 67.1873 132.843 65.3529 132.843 63.5C132.843 28.4299 104.413 0 69.343 0C34.2729 0 5.84302 28.4299 5.84302 63.5C5.84302 65.3529 5.92238 67.1873 6.0779 69H132.608Z",
        fill: "#EEF2F6"
      }
    ),
    /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M0 69C0 68.4477 0.447715 68 1 68H137.36C137.912 68 138.36 68.4477 138.36 69C138.36 69.5523 137.912 70 137.36 70H1C0.447715 70 0 69.5523 0 69Z",
        fill: "#CCD6E0"
      }
    ),
    /* @__PURE__ */ React27.createElement("g", null, /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M48 25.71C48 26.98 48.5 28.2 49.4 29.1C50.3 30 51.52 30.5 52.79 30.5H85.38C86 30.5 86.63 30.38 87.21 30.14C87.79 29.89 88.32 29.54 88.76 29.1C89.21 28.65 89.56 28.12 89.8 27.54C90.04 26.96 90.17 26.34 90.17 25.71V23.79C90.17 22.52 89.66 21.3 88.76 20.4C87.87 19.5 86.65 19 85.38 19H52.79C51.52 19 50.3 19.5 49.4 20.4C48.5 21.3 48 22.52 48 23.79V25.71Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M79.68 37.21C82.94 37.21 86.09 38.4 88.53 40.55C88.66 40.65 88.81 40.72 88.97 40.75C89.13 40.78 89.29 40.77 89.45 40.72C89.6 40.67 89.74 40.57 89.85 40.45C89.96 40.33 90.04 40.18 90.07 40.02C90.19 39.09 90.22 38.15 90.17 37.21C90.17 35.94 89.66 34.72 88.76 33.82C87.87 32.92 86.65 32.42 85.38 32.42H52.79C51.52 32.42 50.3 32.92 49.4 33.82C48.5 34.72 48 35.94 48 37.21V39.13C48 40.4 48.5 41.61 49.4 42.51C50.3 43.41 51.52 43.92 52.79 43.92H67.53C67.69 43.92 67.84 43.87 67.98 43.8C68.12 43.72 68.24 43.6 68.32 43.47C69.53 41.55 71.21 39.97 73.2 38.88C75.18 37.79 77.41 37.21 79.68 37.21Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M52.79 57.33H66.44C66.6 57.33 66.75 57.3 66.89 57.22C67.03 57.15 67.15 57.04 67.24 56.91C67.32 56.78 67.38 56.63 67.39 56.47C67.41 56.31 67.38 56.16 67.32 56.01C66.08 53.17 65.87 49.99 66.73 47.02C66.76 46.88 66.76 46.73 66.73 46.59C66.7 46.45 66.64 46.31 66.55 46.2C66.46 46.08 66.34 45.99 66.22 45.93C66.08 45.87 65.94 45.83 65.8 45.83H52.79C51.52 45.83 50.3 46.34 49.4 47.24C48.5 48.14 48 49.35 48 50.63V52.54C48 53.81 48.5 55.03 49.4 55.93C50.3 56.83 51.52 57.33 52.79 57.33Z",
        fill: "#94A6B8"
      }
    ), /* @__PURE__ */ React27.createElement(
      "path",
      {
        d: "M69.08 50.68C69.08 52.58 69.59 54.45 70.56 56.08C71.53 57.72 72.91 59.06 74.58 59.98C76.25 60.89 78.13 61.34 80.03 61.27C81.93 61.21 83.77 60.64 85.38 59.61C85.47 59.55 85.58 59.53 85.68 59.54C85.79 59.55 85.89 59.6 85.97 59.68L90.73 64.44C91.09 64.79 91.58 64.98 92.08 64.98C92.58 64.97 93.06 64.77 93.42 64.42C93.77 64.06 93.98 63.58 93.98 63.08C93.99 62.57 93.79 62.09 93.44 61.73L88.68 56.97C88.6 56.89 88.56 56.79 88.54 56.68C88.53 56.57 88.56 56.46 88.62 56.37C89.5 54.98 90.04 53.41 90.21 51.77C90.38 50.14 90.17 48.49 89.59 46.95C89.01 45.41 88.08 44.03 86.87 42.91C85.67 41.79 84.22 40.97 82.64 40.51C81.06 40.05 79.4 39.97 77.78 40.26C76.16 40.56 74.64 41.22 73.32 42.21C72.01 43.2 70.94 44.48 70.2 45.95C69.47 47.42 69.08 49.04 69.08 50.68ZM79.68 43.92C81.02 43.92 82.33 44.31 83.44 45.06C84.55 45.8 85.42 46.86 85.93 48.09C86.44 49.33 86.58 50.69 86.31 52C86.05 53.31 85.41 54.52 84.46 55.46C83.52 56.41 82.31 57.05 81 57.31C79.69 57.58 78.33 57.44 77.09 56.93C75.86 56.42 74.8 55.55 74.06 54.44C73.31 53.33 72.92 52.02 72.92 50.68C72.92 48.89 73.63 47.17 74.9 45.9C76.17 44.63 77.89 43.92 79.68 43.92Z",
        fill: "#94A6B8"
      }
    ))
  );
};
var empty_list_search_icon_default = EmptyListSearchIcon;

// src/icons/cog-icon.tsx
import * as React28 from "react";
var CogIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React28.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React28.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React28.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React28.createElement(
      "path",
      {
        d: "M22.5 9.5H20.638C20.4529 8.8602 20.197 8.24305 19.875 7.66L21.192 6.344C21.3314 6.2047 21.442 6.0393 21.5174 5.85725C21.5928 5.6752 21.6317 5.48006 21.6317 5.283C21.6317 5.08594 21.5928 4.8908 21.5174 4.70875C21.442 4.5267 21.3314 4.3613 21.192 4.222L19.777 2.809C19.4957 2.52779 19.1142 2.36982 18.7165 2.36982C18.3188 2.36982 17.9373 2.52779 17.656 2.809L16.338 4.126C15.7558 3.8038 15.1392 3.54787 14.5 3.363V1.5C14.5 1.10218 14.342 0.720644 14.0607 0.43934C13.7794 0.158035 13.3978 0 13 0L11 0C10.6022 0 10.2206 0.158035 9.93934 0.43934C9.65804 0.720644 9.5 1.10218 9.5 1.5V3.363C8.86058 3.5483 8.24378 3.8042 7.661 4.126L6.343 2.809C6.06171 2.52779 5.68025 2.36982 5.2825 2.36982C4.88475 2.36982 4.50329 2.52779 4.222 2.809L2.807 4.223C2.66761 4.3623 2.55703 4.5277 2.48159 4.70975C2.40615 4.8918 2.36732 5.08694 2.36732 5.284C2.36732 5.48106 2.40615 5.6762 2.48159 5.85825C2.55703 6.0403 2.66761 6.2057 2.807 6.345L4.125 7.662C3.80259 8.24413 3.54665 8.86067 3.362 9.5H1.5C1.10218 9.5 0.720644 9.65804 0.43934 9.93934C0.158035 10.2206 0 10.6022 0 11L0 13C0 13.3978 0.158035 13.7794 0.43934 14.0607C0.720644 14.342 1.10218 14.5 1.5 14.5H3.362C3.54657 15.1397 3.80252 15.7565 4.125 16.339L2.806 17.658C2.52479 17.9393 2.36682 18.3208 2.36682 18.7185C2.36682 19.1162 2.52479 19.4977 2.806 19.779L4.22 21.193C4.50682 21.464 4.88643 21.6149 5.281 21.6149C5.67557 21.6149 6.05518 21.464 6.342 21.193L7.66 19.876C8.24309 20.1981 8.86022 20.4544 9.5 20.64V22.5C9.5 22.8978 9.65804 23.2794 9.93934 23.5607C10.2206 23.842 10.6022 24 11 24H13C13.3978 24 13.7794 23.842 14.0607 23.5607C14.342 23.2794 14.5 22.8978 14.5 22.5V20.64C15.1394 20.4547 15.7562 20.1988 16.339 19.877L17.657 21.194C17.9383 21.4752 18.3198 21.6332 18.7175 21.6332C19.1152 21.6332 19.4967 21.4752 19.778 21.194L21.192 19.78C21.4732 19.4987 21.6312 19.1172 21.6312 18.7195C21.6312 18.3218 21.4732 17.9403 21.192 17.659L19.875 16.342C20.1973 15.7591 20.4532 15.1419 20.638 14.502H22.5C22.6972 14.502 22.8924 14.4631 23.0745 14.3876C23.2566 14.3121 23.4221 14.2015 23.5614 14.062C23.7007 13.9225 23.8111 13.7569 23.8864 13.5746C23.9617 13.3924 24.0003 13.1972 24 13V11C24 10.6022 23.842 10.2206 23.5607 9.93934C23.2794 9.65804 22.8978 9.5 22.5 9.5ZM12 17C11.0111 17 10.0444 16.7068 9.22215 16.1573C8.3999 15.6079 7.75904 14.827 7.3806 13.9134C7.00216 12.9998 6.90315 11.9945 7.09607 11.0245C7.289 10.0546 7.7652 9.16373 8.46447 8.46447C9.16373 7.7652 10.0546 7.289 11.0245 7.09607C11.9945 6.90315 12.9998 7.00216 13.9134 7.3806C14.827 7.75904 15.6079 8.3999 16.1573 9.22215C16.7068 10.0444 17 11.0111 17 12C16.9984 13.3256 16.4711 14.5964 15.5338 15.5338C14.5964 16.4711 13.3256 16.9984 12 17Z",
        fill: color
      }
    )
  );
};
var cog_icon_default = CogIcon;

// src/icons/logout-icon.tsx
import * as React29 from "react";
var LogoutIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React29.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React29.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React29.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React29.createElement(
      "path",
      {
        d: "M13.5 17.5C13.2348 17.5 12.9804 17.6054 12.7929 17.7929C12.6054 17.9804 12.5 18.2348 12.5 18.5V21C12.5 21.1326 12.4473 21.2598 12.3536 21.3536C12.2598 21.4473 12.1326 21.5 12 21.5H2.5C2.36739 21.5 2.24021 21.4473 2.14645 21.3536C2.05268 21.2598 2 21.1326 2 21V3C2 2.86739 2.05268 2.74021 2.14645 2.64645C2.24021 2.55268 2.36739 2.5 2.5 2.5H12C12.1326 2.5 12.2598 2.55268 12.3536 2.64645C12.4473 2.74021 12.5 2.86739 12.5 3V5.5C12.5 5.76522 12.6054 6.01957 12.7929 6.20711C12.9804 6.39464 13.2348 6.5 13.5 6.5C13.7652 6.5 14.0196 6.39464 14.2071 6.20711C14.3946 6.01957 14.5 5.76522 14.5 5.5V2.5C14.5 1.96957 14.2893 1.46086 13.9142 1.08579C13.5391 0.710714 13.0304 0.5 12.5 0.5H2C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5L0 21.5C0 22.0304 0.210714 22.5391 0.585786 22.9142C0.960859 23.2893 1.46957 23.5 2 23.5H12.5C13.0304 23.5 13.5391 23.2893 13.9142 22.9142C14.2893 22.5391 14.5 22.0304 14.5 21.5V18.5C14.5 18.2348 14.3946 17.9804 14.2071 17.7929C14.0196 17.6054 13.7652 17.5 13.5 17.5Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React29.createElement(
      "path",
      {
        d: "M23.555 11.669L17.555 7.669C17.4045 7.56857 17.2295 7.51087 17.0488 7.50204C16.868 7.49322 16.6883 7.5336 16.5287 7.61889C16.3691 7.70418 16.2356 7.83118 16.1425 7.98635C16.0494 8.14152 16.0002 8.31905 16 8.5V11H7C6.80302 11 6.60796 11.0388 6.42597 11.1142C6.24399 11.1896 6.07863 11.3001 5.93934 11.4393C5.80005 11.5786 5.68956 11.744 5.61418 11.926C5.5388 12.108 5.5 12.303 5.5 12.5C5.5 12.697 5.5388 12.892 5.61418 13.074C5.68956 13.256 5.80005 13.4214 5.93934 13.5607C6.07863 13.7 6.24399 13.8104 6.42597 13.8858C6.60796 13.9612 6.80302 14 7 14H16V16.5C16.0036 16.7641 16.1101 17.0163 16.2969 17.2031C16.4837 17.3899 16.7359 17.4964 17 17.5C17.1975 17.5 17.3907 17.4416 17.555 17.332L23.555 13.332C23.692 13.2407 23.8043 13.117 23.8819 12.9718C23.9596 12.8267 24.0002 12.6646 24.0002 12.5C24.0002 12.3354 23.9596 12.1733 23.8819 12.0282C23.8043 11.883 23.692 11.7603 23.555 11.669Z",
        fill: color
      }
    )
  );
};
var logout_icon_default = LogoutIcon;

// src/icons/download-data-grid-icon.tsx
import * as React30 from "react";
var DownloadDataGridIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React30.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React30.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React30.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        d: "M8 19C7.9337 19 7.87011 18.9737 7.82322 18.9268C7.77634 18.8799 7.75 18.8163 7.75 18.75V15C7.75 14.9337 7.77634 14.8701 7.82322 14.8232C7.87011 14.7763 7.9337 14.75 8 14.75H9.825C9.8753 14.7499 9.9244 14.7347 9.96595 14.7063C10.0075 14.678 10.0396 14.6378 10.058 14.591C10.1882 14.2579 10.3405 13.9338 10.514 13.621C10.5359 13.5833 10.5474 13.5406 10.5474 13.497C10.5474 13.4534 10.5359 13.4107 10.514 13.373C10.4919 13.3357 10.4604 13.3047 10.4227 13.2831C10.385 13.2616 10.3424 13.2502 10.299 13.25H8C7.9337 13.25 7.87011 13.2237 7.82322 13.1768C7.77634 13.1299 7.75 13.0663 7.75 13V8C7.75 7.9337 7.77634 7.87011 7.82322 7.82322C7.87011 7.77634 7.9337 7.75 8 7.75H12C12.0663 7.75 12.1299 7.77634 12.1768 7.82322C12.2237 7.87011 12.25 7.9337 12.25 8V10.95C12.25 10.9964 12.2629 11.0419 12.2873 11.0814C12.3117 11.1209 12.3467 11.1528 12.3882 11.1736C12.4297 11.1944 12.4762 11.2032 12.5225 11.199C12.5687 11.1948 12.6129 11.1779 12.65 11.15C12.9573 10.913 13.2815 10.6988 13.62 10.509C13.6589 10.4874 13.6912 10.4558 13.7137 10.4175C13.7362 10.3791 13.7481 10.3355 13.748 10.291V8C13.748 7.967 13.7545 7.93433 13.7672 7.90386C13.7799 7.8734 13.7985 7.84575 13.8219 7.82251C13.8454 7.79927 13.8732 7.7809 13.9037 7.76845C13.9343 7.75601 13.967 7.74974 14 7.75H17.75C17.8163 7.75 17.8799 7.77634 17.9268 7.82322C17.9737 7.87011 18 7.9337 18 8V9.294C18.0002 9.35642 18.0237 9.41652 18.0659 9.46256C18.108 9.5086 18.1658 9.53728 18.228 9.543C18.7199 9.58591 19.2066 9.67462 19.682 9.808C19.7191 9.8185 19.7582 9.82025 19.7961 9.81314C19.834 9.80602 19.8698 9.79022 19.9006 9.76697C19.9314 9.74373 19.9564 9.71367 19.9736 9.67915C19.9909 9.64463 19.9999 9.60659 20 9.568V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.31607 17.7956 0 17 0L3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3L0 18C0 18.7956 0.31607 19.5587 0.87868 20.1213C1.44129 20.6839 2.20435 21 3 21H9.927C9.96837 20.9999 10.0091 20.9895 10.0455 20.9699C10.0818 20.9502 10.1128 20.9217 10.1355 20.8872C10.1582 20.8526 10.1719 20.8129 10.1755 20.7717C10.1791 20.7304 10.1724 20.689 10.156 20.651C9.95251 20.1824 9.7951 19.6951 9.686 19.196C9.67451 19.1397 9.64397 19.0891 9.59953 19.0527C9.55509 19.0162 9.49946 18.9962 9.442 18.996L8 19ZM6.25 13C6.25 13.0663 6.22366 13.1299 6.17678 13.1768C6.12989 13.2237 6.0663 13.25 6 13.25H2.25C2.1837 13.25 2.12011 13.2237 2.07322 13.1768C2.02634 13.1299 2 13.0663 2 13V8C2 7.9337 2.02634 7.87011 2.07322 7.82322C2.12011 7.77634 2.1837 7.75 2.25 7.75H6C6.0663 7.75 6.12989 7.77634 6.17678 7.82322C6.22366 7.87011 6.25 7.9337 6.25 8V13ZM8 6.25C7.9337 6.25 7.87011 6.22366 7.82322 6.17678C7.77634 6.12989 7.75 6.0663 7.75 6V2.25C7.75 2.1837 7.77634 2.12011 7.82322 2.07322C7.87011 2.02634 7.9337 2 8 2H12C12.0663 2 12.1299 2.02634 12.1768 2.07322C12.2237 2.12011 12.25 2.1837 12.25 2.25V6C12.25 6.0663 12.2237 6.12989 12.1768 6.17678C12.1299 6.22366 12.0663 6.25 12 6.25H8ZM18 3V6C18 6.0663 17.9737 6.12989 17.9268 6.17678C17.8799 6.22366 17.8163 6.25 17.75 6.25H14C13.9337 6.25 13.8701 6.22366 13.8232 6.17678C13.7763 6.12989 13.75 6.0663 13.75 6V2.25C13.75 2.1837 13.7763 2.12011 13.8232 2.07322C13.8701 2.02634 13.9337 2 14 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3ZM3 2H6C6.0663 2 6.12989 2.02634 6.17678 2.07322C6.22366 2.12011 6.25 2.1837 6.25 2.25V6C6.25 6.0663 6.22366 6.12989 6.17678 6.17678C6.12989 6.22366 6.0663 6.25 6 6.25H2.25C2.1837 6.25 2.12011 6.22366 2.07322 6.17678C2.02634 6.12989 2 6.0663 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2ZM2 18V15C2 14.9337 2.02634 14.8701 2.07322 14.8232C2.12011 14.7763 2.1837 14.75 2.25 14.75H6C6.0663 14.75 6.12989 14.7763 6.17678 14.8232C6.22366 14.8701 6.25 14.9337 6.25 15V18.75C6.25 18.8163 6.22366 18.8799 6.17678 18.9268C6.12989 18.9737 6.0663 19 6 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React30.createElement(
      "path",
      {
        d: "M17.5 11C16.2144 11 14.9577 11.3812 13.8888 12.0954C12.8199 12.8097 11.9868 13.8248 11.4948 15.0126C11.0028 16.2003 10.8741 17.5072 11.1249 18.7681C11.3757 20.029 11.9948 21.1872 12.9038 22.0962C13.8128 23.0052 14.971 23.6243 16.2319 23.8751C17.4928 24.1259 18.7997 23.9972 19.9874 23.5052C21.1752 23.0132 22.1903 22.1801 22.9046 21.1112C23.6188 20.0423 24 18.7856 24 17.5C23.9979 15.7767 23.3124 14.1247 22.0939 12.9061C20.8753 11.6876 19.2233 11.0021 17.5 11ZM17.109 20.812L15.109 18.312C15.0502 18.2384 15.0135 18.1497 15.0029 18.0562C14.9923 17.9626 15.0084 17.8679 15.0492 17.7831C15.0901 17.6982 15.1541 17.6266 15.2338 17.5766C15.3136 17.5265 15.4058 17.4999 15.5 17.5H16.5C16.5663 17.5 16.6299 17.4737 16.6768 17.4268C16.7237 17.3799 16.75 17.3163 16.75 17.25V14.5C16.75 14.3011 16.829 14.1103 16.9697 13.9697C17.1103 13.829 17.3011 13.75 17.5 13.75C17.6989 13.75 17.8897 13.829 18.0303 13.9697C18.171 14.1103 18.25 14.3011 18.25 14.5V17.25C18.25 17.3163 18.2763 17.3799 18.3232 17.4268C18.3701 17.4737 18.4337 17.5 18.5 17.5H19.5C19.5942 17.4999 19.6864 17.5265 19.7662 17.5766C19.8459 17.6266 19.9099 17.6982 19.9508 17.7831C19.9916 17.8679 20.0077 17.9626 19.9971 18.0562C19.9866 18.1497 19.9498 18.2384 19.891 18.312L17.891 20.812C17.8442 20.8708 17.7847 20.9182 17.717 20.9508C17.6493 20.9834 17.5751 21.0004 17.5 21.0004C17.4249 21.0004 17.3507 20.9834 17.283 20.9508C17.2153 20.9182 17.1558 20.8708 17.109 20.812Z",
        fill: color
      }
    )
  );
};
var download_data_grid_icon_default = DownloadDataGridIcon;

// src/icons/cog-data-report-icon.tsx
import * as React31 from "react";
var CogDataReportIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React31.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React31.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React31.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React31.createElement("g", { clipPath: "url(#clip0_2142_5006)" }, /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M16.001 5.5H15.001C14.7248 5.5 14.501 5.72386 14.501 6V13C14.501 13.2761 14.7248 13.5 15.001 13.5H16.001C16.2771 13.5 16.501 13.2761 16.501 13V6C16.501 5.72386 16.2771 5.5 16.001 5.5Z",
        fill: color
      }
    ), /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M19.501 7.5H18.501C18.2248 7.5 18.001 7.72386 18.001 8V13C18.001 13.2761 18.2248 13.5 18.501 13.5H19.501C19.7771 13.5 20.001 13.2761 20.001 13V8C20.001 7.72386 19.7771 7.5 19.501 7.5Z",
        fill: color
      }
    ), /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M21 0.586C20.625 0.210901 20.1164 0.000113275 19.586 0L8.00002 0C7.46959 0 6.96088 0.210714 6.58581 0.585786C6.21073 0.960859 6.00002 1.46957 6.00002 2V8.356C5.99924 8.41634 6.02057 8.47489 6.06 8.52058C6.09942 8.56627 6.15421 8.59594 6.21402 8.604C6.70637 8.66363 7.19191 8.77011 7.66402 8.922C7.70174 8.93606 7.7423 8.94078 7.78224 8.93573C7.82217 8.93068 7.86029 8.91603 7.89332 8.89302C7.92636 8.87002 7.95332 8.83935 7.9719 8.80364C7.99048 8.76793 8.00013 8.72825 8.00002 8.688V2.5C8.00002 2.36739 8.0527 2.24021 8.14647 2.14645C8.24024 2.05268 8.36741 2 8.50002 2H19.38C19.5124 2.00003 19.6393 2.05253 19.733 2.146L21.854 4.268C21.9475 4.36171 22 4.48865 22 4.621V18C22 18.1326 21.9473 18.2598 21.8536 18.3536C21.7598 18.4473 21.6326 18.5 21.5 18.5H14.126C14.0875 18.5004 14.0496 18.5098 14.0152 18.5273C13.9809 18.5449 13.9512 18.5702 13.9283 18.6012C13.9054 18.6322 13.89 18.6681 13.8834 18.7061C13.8768 18.7441 13.879 18.7831 13.89 18.82C14.0046 19.2703 14.0206 19.74 13.937 20.197C13.9295 20.2329 13.93 20.2701 13.9385 20.3058C13.9471 20.3415 13.9634 20.3749 13.9863 20.4036C14.0092 20.4322 14.0382 20.4555 14.0712 20.4716C14.1042 20.4878 14.1403 20.4965 14.177 20.497H22C22.5305 20.497 23.0392 20.2863 23.4142 19.9112C23.7893 19.5361 24 19.0274 24 18.497V4.414C24.0002 3.88375 23.7898 3.37515 23.415 3L21 0.586Z",
        fill: color
      }
    ), /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M12.858 11.959C12.907 12.001 13.001 11.941 13.001 11.859V10.5C13.001 10.3674 12.9483 10.2402 12.8545 10.1464C12.7608 10.0527 12.6336 10 12.501 10H11.501C11.3684 10 11.2412 10.0527 11.1474 10.1464C11.0537 10.2402 11.001 10.3674 11.001 10.5V11.041C11.0057 11.0747 11.0205 11.1062 11.0436 11.1312C11.0666 11.1562 11.0968 11.1736 11.13 11.181C11.7711 11.2608 12.3733 11.5319 12.858 11.959Z",
        fill: color
      }
    ), /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M6.25098 18.531C7.0794 18.531 7.75098 17.8594 7.75098 17.031C7.75098 16.2026 7.0794 15.531 6.25098 15.531C5.42255 15.531 4.75098 16.2026 4.75098 17.031C4.75098 17.8594 5.42255 18.531 6.25098 18.531Z",
        fill: color
      }
    ), /* @__PURE__ */ React31.createElement(
      "path",
      {
        d: "M0.483113 18.408C0.222906 18.6868 0.0590133 19.0418 0.0155294 19.4206C-0.0279545 19.7995 0.051264 20.1824 0.241539 20.5129C0.431814 20.8434 0.723108 21.1042 1.0726 21.2568C1.42209 21.4095 1.81133 21.446 2.18311 21.361L3.59311 21.035C3.70496 21.0096 3.82227 21.0276 3.92138 21.0853C4.02048 21.143 4.09401 21.2362 4.12711 21.346L4.55111 22.738C4.66088 23.1035 4.88553 23.4239 5.19176 23.6517C5.49798 23.8795 5.86947 24.0025 6.25111 24.0025C6.63276 24.0025 7.00424 23.8795 7.31047 23.6517C7.61669 23.4239 7.84135 23.1035 7.95111 22.738L8.37511 21.346C8.40801 21.2363 8.48134 21.1431 8.58028 21.0854C8.67923 21.0277 8.7964 21.0096 8.90811 21.035L10.3191 21.361C10.6909 21.446 11.0801 21.4095 11.4296 21.2568C11.7791 21.1042 12.0704 20.8434 12.2607 20.5129C12.451 20.1824 12.5302 19.7995 12.4867 19.4206C12.4432 19.0418 12.2793 18.6868 12.0191 18.408L11.0311 17.344C10.953 17.2586 10.9097 17.1472 10.9097 17.0315C10.9097 16.9158 10.953 16.8043 11.0311 16.719L12.0191 15.654C12.2793 15.3752 12.4432 15.0202 12.4867 14.6413C12.5302 14.2625 12.451 13.8796 12.2607 13.5491C12.0704 13.2186 11.7791 12.9578 11.4296 12.8052C11.0801 12.6525 10.6909 12.616 10.3191 12.701L8.90911 13.027C8.79736 13.0532 8.67982 13.0357 8.58056 12.978C8.48129 12.9204 8.4078 12.827 8.37511 12.717L7.95011 11.324C7.84035 10.9585 7.61569 10.6381 7.30947 10.4103C7.00324 10.1825 6.63176 10.0595 6.25011 10.0595C5.86847 10.0595 5.49698 10.1825 5.19076 10.4103C4.88453 10.6381 4.65988 10.9585 4.55011 11.324L4.12611 12.717C4.0922 12.826 4.01864 12.9183 3.91995 12.9757C3.82126 13.0331 3.70463 13.0514 3.59311 13.027L2.18411 12.7C1.81233 12.615 1.42309 12.6515 1.0736 12.8042C0.724108 12.9568 0.432814 13.2176 0.242539 13.5481C0.052264 13.8786 -0.0269545 14.2615 0.0165294 14.6403C0.0600133 15.0192 0.223906 15.3742 0.484113 15.653L1.47211 16.718C1.55018 16.8033 1.59348 16.9148 1.59348 17.0305C1.59348 17.1462 1.55018 17.2576 1.47211 17.343L0.483113 18.408ZM6.25111 14.031C6.84446 14.031 7.42448 14.2069 7.91782 14.5366C8.41117 14.8662 8.79569 15.3348 9.02275 15.8829C9.24981 16.4311 9.30922 17.0343 9.19347 17.6163C9.07771 18.1982 8.79199 18.7328 8.37243 19.1523C7.95288 19.5719 7.41833 19.8576 6.83638 19.9734C6.25444 20.0891 5.65124 20.0297 5.10306 19.8026C4.55488 19.5756 4.08635 19.1911 3.7567 18.6977C3.42706 18.2044 3.25111 17.6243 3.25111 17.031C3.25111 16.637 3.32871 16.2469 3.47947 15.8829C3.63024 15.519 3.85122 15.1883 4.12979 14.9097C4.40837 14.6311 4.73909 14.4101 5.10306 14.2594C5.46704 14.1086 5.85715 14.031 6.25111 14.031Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React31.createElement("defs", null, /* @__PURE__ */ React31.createElement("clipPath", { id: "clip0_2142_5006" }, /* @__PURE__ */ React31.createElement("rect", { width: "24", height: "24", fill: "white" })))
  );
};
var cog_data_report_icon_default = CogDataReportIcon;

// src/icons/building-icon.tsx
import * as React32 from "react";
var BuildingIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React32.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React32.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React32.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React32.createElement("g", { clipPath: "url(#clip0_2142_5018)" }, /* @__PURE__ */ React32.createElement(
      "path",
      {
        d: "M24 3C24 2.80109 23.921 2.61032 23.7803 2.46967C23.6397 2.32902 23.4489 2.25 23.25 2.25H0.75C0.551088 2.25 0.360322 2.32902 0.21967 2.46967C0.0790176 2.61032 0 2.80109 0 3C0 3.19891 0.0790176 3.38968 0.21967 3.53033C0.360322 3.67098 0.551088 3.75 0.75 3.75H1.5C1.63261 3.75 1.75979 3.80268 1.85355 3.89645C1.94732 3.99021 2 4.11739 2 4.25V21.25C2 21.3826 2.05268 21.5098 2.14645 21.6036C2.24021 21.6973 2.36739 21.75 2.5 21.75H9C9.13261 21.75 9.25979 21.6973 9.35355 21.6036C9.44732 21.5098 9.5 21.3826 9.5 21.25V18.75C9.5 18.087 9.76339 17.4511 10.2322 16.9822C10.7011 16.5134 11.337 16.25 12 16.25C12.663 16.25 13.2989 16.5134 13.7678 16.9822C14.2366 17.4511 14.5 18.087 14.5 18.75V21.25C14.5 21.3826 14.5527 21.5098 14.6464 21.6036C14.7402 21.6973 14.8674 21.75 15 21.75H21.5C21.6326 21.75 21.7598 21.6973 21.8536 21.6036C21.9473 21.5098 22 21.3826 22 21.25V4.25C22 4.11739 22.0527 3.99021 22.1464 3.89645C22.2402 3.80268 22.3674 3.75 22.5 3.75H23.25C23.4489 3.75 23.6397 3.67098 23.7803 3.53033C23.921 3.38968 24 3.19891 24 3ZM9.25 14.25H5.25C5.05109 14.25 4.86032 14.171 4.71967 14.0303C4.57902 13.8897 4.5 13.6989 4.5 13.5C4.5 13.3011 4.57902 13.1103 4.71967 12.9697C4.86032 12.829 5.05109 12.75 5.25 12.75H9.25C9.44891 12.75 9.63968 12.829 9.78033 12.9697C9.92098 13.1103 10 13.3011 10 13.5C10 13.6989 9.92098 13.8897 9.78033 14.0303C9.63968 14.171 9.44891 14.25 9.25 14.25ZM9.25 10.25H5.25C5.05109 10.25 4.86032 10.171 4.71967 10.0303C4.57902 9.88968 4.5 9.69891 4.5 9.5C4.5 9.30109 4.57902 9.11032 4.71967 8.96967C4.86032 8.82902 5.05109 8.75 5.25 8.75H9.25C9.44891 8.75 9.63968 8.82902 9.78033 8.96967C9.92098 9.11032 10 9.30109 10 9.5C10 9.69891 9.92098 9.88968 9.78033 10.0303C9.63968 10.171 9.44891 10.25 9.25 10.25ZM9.25 6.25H5.25C5.05109 6.25 4.86032 6.17098 4.71967 6.03033C4.57902 5.88968 4.5 5.69891 4.5 5.5C4.5 5.30109 4.57902 5.11032 4.71967 4.96967C4.86032 4.82902 5.05109 4.75 5.25 4.75H9.25C9.44891 4.75 9.63968 4.82902 9.78033 4.96967C9.92098 5.11032 10 5.30109 10 5.5C10 5.69891 9.92098 5.88968 9.78033 6.03033C9.63968 6.17098 9.44891 6.25 9.25 6.25ZM18.75 14.25H14.75C14.5511 14.25 14.3603 14.171 14.2197 14.0303C14.079 13.8897 14 13.6989 14 13.5C14 13.3011 14.079 13.1103 14.2197 12.9697C14.3603 12.829 14.5511 12.75 14.75 12.75H18.75C18.9489 12.75 19.1397 12.829 19.2803 12.9697C19.421 13.1103 19.5 13.3011 19.5 13.5C19.5 13.6989 19.421 13.8897 19.2803 14.0303C19.1397 14.171 18.9489 14.25 18.75 14.25ZM18.75 10.25H14.75C14.5511 10.25 14.3603 10.171 14.2197 10.0303C14.079 9.88968 14 9.69891 14 9.5C14 9.30109 14.079 9.11032 14.2197 8.96967C14.3603 8.82902 14.5511 8.75 14.75 8.75H18.75C18.9489 8.75 19.1397 8.82902 19.2803 8.96967C19.421 9.11032 19.5 9.30109 19.5 9.5C19.5 9.69891 19.421 9.88968 19.2803 10.0303C19.1397 10.171 18.9489 10.25 18.75 10.25ZM19.5 5.5C19.5 5.69891 19.421 5.88968 19.2803 6.03033C19.1397 6.17098 18.9489 6.25 18.75 6.25H14.75C14.5511 6.25 14.3603 6.17098 14.2197 6.03033C14.079 5.88968 14 5.69891 14 5.5C14 5.30109 14.079 5.11032 14.2197 4.96967C14.3603 4.82902 14.5511 4.75 14.75 4.75H18.75C18.9489 4.75 19.1397 4.82902 19.2803 4.96967C19.421 5.11032 19.5 5.30109 19.5 5.5Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React32.createElement("defs", null, /* @__PURE__ */ React32.createElement("clipPath", { id: "clip0_2142_5018" }, /* @__PURE__ */ React32.createElement("rect", { width: "24", height: "24", fill: "white" })))
  );
};
var building_icon_default = BuildingIcon;

// src/icons/monitor-heart-beat-search-icon.tsx
import * as React33 from "react";
var MonitorHeartBeatSearchIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React33.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React33.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React33.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React33.createElement("g", { clipPath: "url(#clip0_2142_5014)" }, /* @__PURE__ */ React33.createElement(
      "path",
      {
        d: "M23.4079 19.09L19.7469 15.43C19.7076 15.3904 19.6826 15.3388 19.6759 15.2833C19.6692 15.2279 19.6812 15.1719 19.7099 15.124C20.5545 13.7296 21.0007 12.1303 20.9999 10.5C20.9989 8.3459 20.2253 6.26362 18.8197 4.63136C17.414 2.9991 15.4695 1.92514 13.3394 1.60453C11.2093 1.28393 9.0349 1.73795 7.21107 2.88414C5.38723 4.03032 4.03498 5.79264 3.39993 7.851C3.37674 7.92527 3.37119 8.00392 3.38375 8.08071C3.3963 8.1575 3.4266 8.2303 3.47224 8.29332C3.51787 8.35634 3.57759 8.40783 3.64663 8.44371C3.71567 8.47959 3.79213 8.49887 3.86993 8.5H4.92493C5.02902 8.5007 5.13073 8.46889 5.21588 8.40902C5.30103 8.34914 5.36537 8.26419 5.39993 8.166C5.94152 6.62527 7.00384 5.32187 8.40366 4.48063C9.80347 3.63939 11.453 3.31306 13.0677 3.55795C14.6823 3.80284 16.1609 4.60357 17.2484 5.82204C18.3358 7.0405 18.9639 8.60027 19.0243 10.2323C19.0847 11.8643 18.5736 13.4663 17.5792 14.7618C16.5848 16.0573 15.1695 16.9651 13.5773 17.3287C11.9851 17.6922 10.316 17.4887 8.85784 16.7533C7.39968 16.0178 6.24392 14.7965 5.58993 13.3C5.55097 13.2107 5.48677 13.1348 5.40522 13.0815C5.32368 13.0282 5.22835 12.9999 5.13093 13H4.04993C3.96898 12.9999 3.88922 13.0195 3.81751 13.0571C3.74581 13.0947 3.68429 13.1491 3.63826 13.2157C3.59223 13.2823 3.56305 13.359 3.55324 13.4394C3.54343 13.5197 3.55327 13.6013 3.58193 13.677C4.22849 15.3871 5.38005 16.86 6.88364 17.9001C8.38722 18.9402 10.1717 19.4982 11.9999 19.5C13.627 19.503 15.2234 19.0577 16.6139 18.213C16.6619 18.1842 16.7182 18.1722 16.7738 18.1789C16.8294 18.1856 16.8811 18.2106 16.9209 18.25L20.5909 21.92C20.7732 22.1204 20.9943 22.2818 21.2408 22.3942C21.4873 22.5066 21.7541 22.5677 22.025 22.5739C22.2958 22.5801 22.5651 22.5312 22.8165 22.4301C23.0679 22.3291 23.2961 22.178 23.4873 21.9861C23.6786 21.7942 23.8288 21.5655 23.929 21.3137C24.0291 21.062 24.0771 20.7925 24.0699 20.5217C24.0628 20.2509 24.0007 19.9843 23.8874 19.7382C23.7741 19.4921 23.612 19.2716 23.4109 19.09H23.4079Z",
        fill: color
      }
    ), /* @__PURE__ */ React33.createElement(
      "path",
      {
        d: "M8.162 10.909L8.785 9.74199C8.80852 9.69804 8.84464 9.66213 8.88872 9.63886C8.93279 9.6156 8.98282 9.60604 9.03237 9.61141C9.08193 9.61679 9.12874 9.63685 9.16681 9.66903C9.20487 9.7012 9.23245 9.74402 9.246 9.79199L10.24 13.34C10.3211 13.6491 10.495 13.9259 10.7381 14.1333C10.9812 14.3406 11.282 14.4686 11.6 14.5C11.6452 14.5045 11.6906 14.5065 11.736 14.506C12.036 14.5028 12.3289 14.4137 12.5798 14.2492C12.8308 14.0847 13.0293 13.8518 13.152 13.578L14.358 10.929C14.3769 10.8877 14.4066 10.8523 14.4441 10.8266C14.4816 10.801 14.5253 10.786 14.5707 10.7833C14.616 10.7806 14.6612 10.7904 14.7015 10.8115C14.7417 10.8325 14.7754 10.8642 14.799 10.903L15.39 11.877C15.4582 11.9893 15.5478 12.087 15.6537 12.1647C15.7596 12.2423 15.8798 12.2984 16.0074 12.3296C16.135 12.3608 16.2675 12.3665 16.3973 12.3465C16.5271 12.3265 16.6517 12.2811 16.764 12.213C16.8763 12.1448 16.974 12.0552 17.0517 11.9493C17.1293 11.8434 17.1854 11.7232 17.2166 11.5956C17.2478 11.468 17.2535 11.3355 17.2335 11.2057C17.2135 11.0759 17.1682 10.9513 17.1 10.839L15.82 8.72999C15.6758 8.48563 15.4667 8.28593 15.216 8.153C14.9654 8.02006 14.6828 7.95907 14.3996 7.97677C14.1164 7.99447 13.8436 8.09017 13.6114 8.25329C13.3792 8.4164 13.1967 8.64057 13.084 8.90099L12.122 11.015C12.1005 11.0615 12.0654 11.1003 12.0212 11.1262C11.9771 11.1521 11.926 11.1639 11.875 11.16C11.8239 11.1562 11.7752 11.1367 11.7356 11.1041C11.696 11.0715 11.6675 11.0274 11.654 10.978L10.705 7.59199C10.6247 7.29175 10.4574 7.02197 10.2241 6.81662C9.99082 6.61127 9.702 6.47953 9.394 6.43799C9.08016 6.39876 8.76187 6.45756 8.48276 6.60633C8.20365 6.75511 7.97739 6.98657 7.835 7.26899L6.512 9.75099H1C0.734784 9.75099 0.48043 9.85634 0.292893 10.0439C0.105357 10.2314 0 10.4858 0 10.751C0 11.0162 0.105357 11.2706 0.292893 11.4581C0.48043 11.6456 0.734784 11.751 1 11.751H6.79C7.07377 11.7493 7.35166 11.6699 7.59352 11.5215C7.83539 11.3731 8.03199 11.1612 8.162 10.909Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React33.createElement("defs", null, /* @__PURE__ */ React33.createElement("clipPath", { id: "clip0_2142_5014" }, /* @__PURE__ */ React33.createElement("rect", { width: "24", height: "24", fill: "white" })))
  );
};
var monitor_heart_beat_search_icon_default = MonitorHeartBeatSearchIcon;

// src/icons/menu-icon.tsx
import * as React34 from "react";
var MenuIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React34.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React34.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React34.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React34.createElement(
      "path",
      {
        fill: color,
        d: "M0 3.5C0 4.325.675 5 1.5 5h21c.825 0 1.5-.675 1.5-1.5S23.325 2 22.5 2h-21C.675 2 0 2.675 0 3.5ZM0 12c0 .825.675 1.5 1.5 1.5h21c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5h-21c-.825 0-1.5.675-1.5 1.5ZM0 20.5c0 .825.675 1.5 1.5 1.5h21c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5h-21c-.825 0-1.5.675-1.5 1.5Z"
      }
    )
  );
};
var menu_icon_default = MenuIcon;

// src/icons/pie-icon.tsx
import * as React35 from "react";
var PieIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React35.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React35.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React35.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React35.createElement("g", { fill: color, clipPath: "url(#a)" }, /* @__PURE__ */ React35.createElement("path", { d: "M15.333 7a.333.333 0 0 0 .334-.333A6.674 6.674 0 0 0 9 0a.333.333 0 0 0-.333.333V6.35a.651.651 0 0 0 .65.65h6.016ZM15.667 8H9.333A.451.451 0 0 0 9 8.805l4.479 4.479a.333.333 0 0 0 .471 0A6.955 6.955 0 0 0 16 8.334.333.333 0 0 0 15.667 8Z" }), /* @__PURE__ */ React35.createElement("path", { d: "M7.059 16a6.88 6.88 0 0 0 4.891-2.056.333.333 0 0 0 0-.471L7.471 8.994a.607.607 0 0 1-.138-.333V2.327A.333.333 0 0 0 7 1.994 7.003 7.003 0 0 0 7.06 16Z" })),
    /* @__PURE__ */ React35.createElement("defs", null, /* @__PURE__ */ React35.createElement("clipPath", { id: "a" }, /* @__PURE__ */ React35.createElement("path", { fill: "transparent", d: "M0 0h16v16H0z" })))
  );
};
var pie_icon_default = PieIcon;

// src/icons/minus-icon.tsx
import React36 from "react";
var MinusIcon = (_a) => {
  var _b = _a, { sizeInPixels = 16, color = "#000" } = _b, props = __objRest(_b, ["sizeInPixels", "color"]);
  var _a2, _b2;
  return /* @__PURE__ */ React36.createElement(
    "svg",
    __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 -960 960 960",
      fill: "none"
    }, props),
    /* @__PURE__ */ React36.createElement("path", { fill: color, d: "M200-440v-80h560v80H200Z" })
  );
};
var minus_icon_default = MinusIcon;

// src/icons/plus-icon.tsx
import React37 from "react";
var PlusIcon = (_a) => {
  var _b = _a, { sizeInPixels = 16, color = "#000" } = _b, props = __objRest(_b, ["sizeInPixels", "color"]);
  var _a2, _b2;
  return /* @__PURE__ */ React37.createElement(
    "svg",
    __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      fill: "none",
      viewBox: "0 -960 960 960"
    }, props),
    /* @__PURE__ */ React37.createElement("path", { fill: color, d: "M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" })
  );
};
var plus_icon_default = PlusIcon;

// src/icons/play-icon.tsx
import * as React38 from "react";
var PlayIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React38.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 10",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React38.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React38.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React38.createElement(
      "path",
      {
        d: "M8.60899 3.71176L2.683 0.748762C2.45073 0.616049 2.18698 0.548405 1.91951 0.552949C1.65204 0.557493 1.39075 0.634057 1.16312 0.774582C0.935496 0.915107 0.749964 1.1144 0.626051 1.35147C0.502139 1.58855 0.444428 1.85465 0.458995 2.12176V7.87576C0.448419 8.14192 0.50742 8.40623 0.630175 8.64262C0.75293 8.87901 0.935199 9.07932 1.159 9.22376C1.38715 9.36433 1.65001 9.43844 1.918 9.43776C2.1828 9.4349 2.44332 9.37054 2.679 9.24976L8.60499 6.28676C8.86258 6.18409 9.08345 6.00652 9.23905 5.777C9.39465 5.54747 9.47783 5.27656 9.47783 4.99926C9.47783 4.72197 9.39465 4.45105 9.23905 4.22153C9.08345 3.992 8.86258 3.81443 8.60499 3.71176H8.60899Z",
        fill: color
      }
    )
  );
};
var play_icon_default = PlayIcon;

// src/icons/bell-icon.tsx
import * as React39 from "react";
var BellIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React39.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React39.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React39.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React39.createElement("g", { clipPath: "url(#clip0_8141_5794)" }, /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M19.25 16.0417C18.4906 16.0417 17.875 15.4261 17.875 14.6667V10.2098C17.9844 6.61318 15.4545 3.47414 11.9167 2.81692V0.916667C11.9167 0.410405 11.5063 0 11 0C10.4937 0 10.0833 0.410405 10.0833 0.916667V2.81692C6.54554 3.47414 4.01563 6.61317 4.125 10.2098V14.6667C4.125 15.4261 3.5094 16.0417 2.75001 16.0417C2.24375 16.0417 1.83334 16.4521 1.83334 16.9583C1.83334 17.4646 2.24375 17.875 2.75001 17.875H19.25C19.7563 17.875 20.1667 17.4646 20.1667 16.9583C20.1667 16.4521 19.7563 16.0417 19.25 16.0417Z",
        fill: color
      }
    ), /* @__PURE__ */ React39.createElement(
      "path",
      {
        d: "M13.0497 19.25H8.95035C8.83387 19.2502 8.73606 19.3378 8.72302 19.4535C8.71303 19.5381 8.70813 19.6232 8.70835 19.7083C8.70835 20.974 9.73437 22 11 22C12.2657 22 13.2917 20.974 13.2917 19.7083C13.2919 19.6232 13.287 19.5381 13.277 19.4535C13.2648 19.3373 13.1665 19.2494 13.0497 19.25Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React39.createElement("defs", null, /* @__PURE__ */ React39.createElement("clipPath", { id: "clip0_8141_5794" }, /* @__PURE__ */ React39.createElement("rect", { width: "22", height: "22", fill: "transparent" })))
  );
};
var bell_icon_default = BellIcon;

// src/icons/settings-icon.tsx
import * as React40 from "react";
var SettingsIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React40.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React40.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React40.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React40.createElement(
      "path",
      {
        d: "M0.75 19.5C0.75 20.1875 1.3125 20.75 2 20.75H8.25V18.25H2C1.3125 18.25 0.75 18.8125 0.75 19.5ZM0.75 4.5C0.75 5.1875 1.3125 5.75 2 5.75H13.25V3.25H2C1.3125 3.25 0.75 3.8125 0.75 4.5ZM13.25 22V20.75H22C22.6875 20.75 23.25 20.1875 23.25 19.5C23.25 18.8125 22.6875 18.25 22 18.25H13.25V17C13.25 16.3125 12.6875 15.75 12 15.75C11.3125 15.75 10.75 16.3125 10.75 17V22C10.75 22.6875 11.3125 23.25 12 23.25C12.6875 23.25 13.25 22.6875 13.25 22ZM5.75 9.5V10.75H2C1.3125 10.75 0.75 11.3125 0.75 12C0.75 12.6875 1.3125 13.25 2 13.25H5.75V14.5C5.75 15.1875 6.3125 15.75 7 15.75C7.6875 15.75 8.25 15.1875 8.25 14.5V9.5C8.25 8.8125 7.6875 8.25 7 8.25C6.3125 8.25 5.75 8.8125 5.75 9.5ZM23.25 12C23.25 11.3125 22.6875 10.75 22 10.75H10.75V13.25H22C22.6875 13.25 23.25 12.6875 23.25 12ZM17 8.25C17.6875 8.25 18.25 7.6875 18.25 7V5.75H22C22.6875 5.75 23.25 5.1875 23.25 4.5C23.25 3.8125 22.6875 3.25 22 3.25H18.25V2C18.25 1.3125 17.6875 0.75 17 0.75C16.3125 0.75 15.75 1.3125 15.75 2V7C15.75 7.6875 16.3125 8.25 17 8.25Z",
        fill: color
      }
    )
  );
};
var settings_icon_default = SettingsIcon;

// src/icons/vehicle-type-trailer-icon.tsx
import * as React41 from "react";
var VehicleTypeTrailerIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 40,
    heightInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React41.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || widthInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || heightInPixels,
      viewBox: "0 0 40 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React41.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React41.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React41.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.0095 14H17.4905C17.4968 13.9175 17.5 13.8341 17.5 13.75C17.5 11.9551 16.0449 10.5 14.25 10.5C12.4551 10.5 11 11.9551 11 13.75C11 13.8341 11.0032 13.9175 11.0095 14H9.49053C9.4968 13.9175 9.5 13.8341 9.5 13.75C9.5 11.9551 8.04493 10.5 6.25 10.5C4.45507 10.5 3 11.9551 3 13.75C3 13.8341 3.0032 13.9175 3.00947 14H2.5C1.39543 14 0.5 13.1046 0.5 12V2C0.5 0.89543 1.39543 0 2.5 0H26.5C27.6046 0 28.5 0.89543 28.5 2V12H29.5V2.41176C29.5 1.63207 30.1321 1 30.9118 1H35.2647C37.6038 1 39.5 2.89621 39.5 5.23529V12.5882C39.5 13.3679 38.8679 14 38.0882 14H37.4905C37.4968 13.9175 37.5 13.8341 37.5 13.75C37.5 11.9551 36.0449 10.5 34.25 10.5C32.4551 10.5 31 11.9551 31 13.75C31 13.8341 31.0032 13.9175 31.0095 14ZM37.5 5.625C37.5 4.17526 36.3247 3 34.875 3H34.2188C34.0979 3 34 3.09794 34 3.21875V6.28125C34 6.40206 34.0979 6.5 34.2188 6.5H37.2812C37.4021 6.5 37.5 6.40206 37.5 6.28125V5.625ZM12 13.75C12 14.9926 13.0074 16 14.25 16C15.4926 16 16.5 14.9926 16.5 13.75C16.5 12.5074 15.4926 11.5 14.25 11.5C13.0074 11.5 12 12.5074 12 13.75ZM6.25 16C5.00736 16 4 14.9926 4 13.75C4 12.5074 5.00736 11.5 6.25 11.5C7.49264 11.5 8.5 12.5074 8.5 13.75C8.5 14.9926 7.49264 16 6.25 16ZM32 13.75C32 14.9926 32.9796 16 34.2222 16C35.4649 16 36.5 14.9926 36.5 13.75C36.5 12.5074 35.4926 11.5 34.25 11.5C33.0074 11.5 32 12.5074 32 13.75Z",
        fill: color
      }
    )
  );
};
var vehicle_type_trailer_icon_default = VehicleTypeTrailerIcon;

// src/icons/vehicle-type-van-icon.tsx
import * as React42 from "react";
var VehicleTypeVanIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 26,
    heightInPixels = 16,
    color = "#94A6B8"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React42.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || widthInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || heightInPixels,
      viewBox: "0 0 26 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React42.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React42.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React42.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.4988 0H1.5C0.947715 0 0.5 0.447715 0.5 1V13C0.5 13.5523 0.947715 14 1.5 14H2.01027C2.00347 13.9176 2 13.8342 2 13.75C2 12.0931 3.34315 10.75 5 10.75C6.65685 10.75 8 12.0931 8 13.75C8 13.8342 7.99653 13.9176 7.98973 14H17.5103C17.5035 13.9176 17.5 13.8342 17.5 13.75C17.5 12.0931 18.8431 10.75 20.5 10.75C22.1569 10.75 23.5 12.0931 23.5 13.75C23.5 13.8342 23.4965 13.9176 23.4897 14H24.4971C25.2029 14 25.5362 13.6111 25.4969 12.8333V9.11832C25.4969 8.35398 25.1636 7.76473 24.4971 7.35056L22.4976 5.83333C20.2619 2.93163 18.9948 1.28262 18.6963 0.886294C18.6547 0.830961 18.62 0.78003 18.5866 0.731037C18.482 0.577618 18.3904 0.443199 18.1385 0.252111C17.9169 0.0840369 17.7037 0 17.4988 0ZM2.75 13.75C2.75 14.9926 3.75736 16 5 16C6.24264 16 7.25 14.9926 7.25 13.75C7.25 12.5074 6.24264 11.5 5 11.5C3.75736 11.5 2.75 12.5074 2.75 13.75ZM20.5 16C19.2574 16 18.25 14.9926 18.25 13.75C18.25 12.5074 19.2574 11.5 20.5 11.5C21.7426 11.5 22.75 12.5074 22.75 13.75C22.75 14.9926 21.7426 16 20.5 16ZM15 5.25V1.75C15 1.61193 15.1119 1.5 15.25 1.5H17.0667C17.2188 1.5 17.3626 1.56922 17.4575 1.68809L20.176 5.09405C20.2113 5.13834 20.2306 5.19333 20.2306 5.25C20.2306 5.38807 20.1187 5.5 19.9806 5.5H15.25C15.1119 5.5 15 5.38807 15 5.25Z",
        fill: color
      }
    )
  );
};
var vehicle_type_van_icon_default = VehicleTypeVanIcon;

// src/icons/bot-icon.tsx
import * as React43 from "react";
var BotIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React43.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React43.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React43.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React43.createElement("path", { d: "M12 8V4H8" }),
    /* @__PURE__ */ React43.createElement("rect", { width: "16", height: "12", x: "4", y: "8", rx: "2" }),
    /* @__PURE__ */ React43.createElement("path", { d: "M2 14h2" }),
    /* @__PURE__ */ React43.createElement("path", { d: "M20 14h2" }),
    /* @__PURE__ */ React43.createElement("path", { d: "M15 13v2" }),
    /* @__PURE__ */ React43.createElement("path", { d: "M9 13v2" })
  );
};
var bot_icon_default = BotIcon;

// src/icons/check-icon.tsx
import * as React44 from "react";
var CheckIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React44.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React44.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React44.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React44.createElement("path", { d: "M5 12l5 5l10 -10" })
  );
};
var check_icon_default = CheckIcon;

// src/icons/pencil-icon.tsx
import * as React45 from "react";
var PencilIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React45.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React45.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React45.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React45.createElement("path", { d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" }),
    /* @__PURE__ */ React45.createElement("path", { d: "M13.5 6.5l4 4" })
  );
};
var pencil_icon_default = PencilIcon;

// src/icons/list-icon.tsx
import * as React46 from "react";
var ListIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 24,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React46.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 20",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React46.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React46.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React46.createElement(
      "path",
      {
        d: "M1.41176 12.8571H4.23529C5.01177 12.8571 5.64706 12.2143 5.64706 11.4286V8.57143C5.64706 7.78571 5.01177 7.14286 4.23529 7.14286H1.41176C0.635294 7.14286 0 7.78571 0 8.57143V11.4286C0 12.2143 0.635294 12.8571 1.41176 12.8571ZM1.41176 20H4.23529C5.01177 20 5.64706 19.3571 5.64706 18.5714V15.7143C5.64706 14.9286 5.01177 14.2857 4.23529 14.2857H1.41176C0.635294 14.2857 0 14.9286 0 15.7143V18.5714C0 19.3571 0.635294 20 1.41176 20ZM1.41176 5.71429H4.23529C5.01177 5.71429 5.64706 5.07143 5.64706 4.28571V1.42857C5.64706 0.642857 5.01177 0 4.23529 0H1.41176C0.635294 0 0 0.642857 0 1.42857V4.28571C0 5.07143 0.635294 5.71429 1.41176 5.71429ZM8.47059 12.8571H22.5882C23.3647 12.8571 24 12.2143 24 11.4286V8.57143C24 7.78571 23.3647 7.14286 22.5882 7.14286H8.47059C7.69412 7.14286 7.05882 7.78571 7.05882 8.57143V11.4286C7.05882 12.2143 7.69412 12.8571 8.47059 12.8571ZM8.47059 20H22.5882C23.3647 20 24 19.3571 24 18.5714V15.7143C24 14.9286 23.3647 14.2857 22.5882 14.2857H8.47059C7.69412 14.2857 7.05882 14.9286 7.05882 15.7143V18.5714C7.05882 19.3571 7.69412 20 8.47059 20ZM7.05882 1.42857V4.28571C7.05882 5.07143 7.69412 5.71429 8.47059 5.71429H22.5882C23.3647 5.71429 24 5.07143 24 4.28571V1.42857C24 0.642857 23.3647 0 22.5882 0H8.47059C7.69412 0 7.05882 0.642857 7.05882 1.42857Z",
        fill: color
      }
    )
  );
};
var list_icon_default = ListIcon;

// src/icons/mail-reply-icon.tsx
import * as React47 from "react";
var MailReplyIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React47.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React47.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React47.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React47.createElement(
      "path",
      {
        d: "M10.8942 11.0417H14.6667V10.9767C14.6581 10.6099 14.7631 10.2494 14.9673 9.94466C15.1716 9.63988 15.465 9.40569 15.8075 9.27417C16.0921 9.17341 16.398 9.14894 16.695 9.20318C16.9919 9.25742 17.2695 9.38849 17.5 9.58333V2.70833C17.5 2.68191 17.4921 2.6561 17.4772 2.63425C17.4623 2.6124 17.4413 2.59553 17.4167 2.58583C17.3925 2.57602 17.366 2.57348 17.3404 2.57851C17.3148 2.58354 17.2912 2.59593 17.2725 2.61417L10.1667 9.72C9.79064 10.0951 9.28117 10.3058 8.75001 10.3058C8.21885 10.3058 7.70937 10.0951 7.33334 9.72L0.227507 2.61417C0.209296 2.59523 0.185835 2.58218 0.160144 2.57668C0.134453 2.57119 0.107705 2.5735 0.0833406 2.58333C0.0584974 2.59338 0.0372583 2.61068 0.0223933 2.63298C0.00752828 2.65528 -0.000272837 2.68154 7.28791e-06 2.70833V11.4583C-0.000102259 11.6499 0.0375439 11.8396 0.110793 12.0165C0.184042 12.1935 0.291458 12.3543 0.426899 12.4898C0.562339 12.6252 0.723148 12.7326 0.900131 12.8059C1.07711 12.8791 1.2668 12.9168 1.45834 12.9167H8.78084C8.85056 12.403 9.10212 11.9314 9.48987 11.5873C9.87763 11.2433 10.3759 11.0497 10.8942 11.0417Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React47.createElement(
      "path",
      {
        d: "M8.10667 8.9475C8.27828 9.11722 8.5099 9.21241 8.75126 9.21241C8.99261 9.21241 9.22423 9.11722 9.39584 8.9475L16.4583 1.88417C16.5062 1.83642 16.5399 1.77628 16.5555 1.71049C16.5712 1.6447 16.5682 1.57585 16.5469 1.51165C16.5256 1.44746 16.4869 1.39046 16.435 1.34705C16.3832 1.30363 16.3203 1.27551 16.2533 1.26583C16.1835 1.25546 16.1131 1.25017 16.0425 1.25H1.45917C1.38888 1.2502 1.3187 1.2555 1.24917 1.26583C1.18224 1.27551 1.11932 1.30363 1.06747 1.34705C1.01562 1.39046 0.976887 1.44746 0.955605 1.51165C0.934323 1.57585 0.931336 1.6447 0.94698 1.71049C0.962623 1.77628 0.996278 1.83642 1.04417 1.88417L8.10667 8.9475Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React47.createElement(
      "path",
      {
        d: "M16.8183 10.6233C16.7539 10.5364 16.6633 10.4723 16.5599 10.4404C16.4565 10.4084 16.3456 10.4103 16.2433 10.4458C16.1394 10.4878 16.0517 10.5621 15.993 10.6576C15.9344 10.7531 15.9079 10.865 15.9175 10.9767V12.2917H10.8942C10.647 12.3027 10.4143 12.4111 10.2467 12.5931C10.0792 12.7752 9.99051 13.0161 10 13.2633V15.9033C9.99052 16.1507 10.0793 16.3917 10.247 16.5738C10.4147 16.7559 10.6477 16.8642 10.895 16.875H15.9167V18.19C15.9094 18.2596 15.9166 18.33 15.9379 18.3967C15.9591 18.4633 15.9939 18.5249 16.0401 18.5775C16.0862 18.6301 16.1428 18.6726 16.2062 18.7023C16.2695 18.7319 16.3384 18.7482 16.4083 18.75C16.4878 18.7484 16.5659 18.7291 16.6368 18.6933C16.7078 18.6575 16.7698 18.6063 16.8183 18.5433L19.8275 15.0525C19.9375 14.9212 19.9978 14.7554 19.9978 14.5842C19.9978 14.4129 19.9375 14.2471 19.8275 14.1158L16.8183 10.6233Z",
        fill: color
      }
    )
  );
};
var mail_reply_icon_default = MailReplyIcon;

// src/icons/message-alert-icon.tsx
import * as React48 from "react";
var MessageAlertIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React48.createElement(
    "svg",
    __spreadValues({
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React48.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React48.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React48.createElement("path", { d: "M8 9h8" }),
    /* @__PURE__ */ React48.createElement("path", { d: "M8 13h6" }),
    /* @__PURE__ */ React48.createElement("path", { d: "M15 18l-3 3l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5" }),
    /* @__PURE__ */ React48.createElement("path", { d: "M19 16v3" }),
    /* @__PURE__ */ React48.createElement("path", { d: "M19 22v.01" })
  );
};
var message_alert_icon_default = MessageAlertIcon;

// src/icons/circle-line-arrow-right-icon.tsx
import * as React49 from "react";
var CircleLineArrowRightIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React49.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 21",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React49.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React49.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React49.createElement(
      "path",
      {
        d: "M10.0003 11.7498V14.8332C10.0005 14.99 10.045 15.1435 10.1286 15.2762C10.2122 15.4089 10.3315 15.5153 10.4728 15.5832C10.6151 15.6477 10.7723 15.6725 10.9276 15.6547C11.0829 15.637 11.2304 15.5774 11.3545 15.4823L16.7712 11.149C16.8686 11.0709 16.9473 10.9719 17.0014 10.8594C17.0555 10.7468 17.0835 10.6235 17.0835 10.4986C17.0835 10.3737 17.0555 10.2504 17.0014 10.1378C16.9473 10.0252 16.8686 9.92626 16.7712 9.84818L11.3545 5.51485C11.2319 5.41666 11.084 5.35514 10.9279 5.33738C10.7718 5.31961 10.6139 5.34633 10.4723 5.41446C10.3307 5.48258 10.2113 5.58933 10.1278 5.72239C10.0443 5.85546 10.0001 6.00941 10.0003 6.16651V9.24985H5.41699C5.08547 9.24985 4.76753 9.38154 4.53311 9.61596C4.29869 9.85038 4.16699 10.1683 4.16699 10.4998C4.16699 10.8314 4.29869 11.1493 4.53311 11.3837C4.76753 11.6181 5.08547 11.7498 5.41699 11.7498H10.0003Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React49.createElement(
      "path",
      {
        d: "M9.894 0.5C11.8032 0.502165 13.6711 1.06113 15.2736 2.10978C16.876 3.15842 18.1449 4.65217 18.9277 6.41167C19.0173 6.61345 19.0239 6.84293 18.946 7.04961C18.8681 7.25629 18.7122 7.42324 18.5125 7.51375C18.3128 7.60425 18.0857 7.61089 17.8812 7.53221C17.6766 7.45352 17.5114 7.29595 17.4218 7.09417C16.6506 5.35502 15.3127 3.93554 13.6312 3.07237C11.9497 2.20919 10.0262 1.95448 8.18141 2.35069C6.33659 2.7469 4.68191 3.77009 3.4932 5.24969C2.30449 6.72929 1.65359 8.5759 1.649 10.4817C1.64442 12.3874 2.28642 14.2372 3.46799 15.7227C4.64956 17.2081 6.2993 18.2394 8.14219 18.6447C9.98508 19.0499 11.9098 18.8047 13.5954 17.9498C15.281 17.0949 16.6257 15.682 17.4053 13.9467C17.4486 13.8446 17.5116 13.7523 17.5906 13.6752C17.6696 13.5981 17.7631 13.5377 17.8655 13.4976C17.968 13.4575 18.0773 13.4385 18.1871 13.4416C18.2969 13.4448 18.405 13.4701 18.505 13.5161C18.605 13.5621 18.6949 13.6278 18.7694 13.7093C18.8439 13.7909 18.9016 13.8867 18.939 13.9911C18.9763 14.0955 18.9927 14.2063 18.9871 14.3172C18.9815 14.4281 18.954 14.5367 18.9063 14.6367C18.1709 16.2722 17.013 17.6774 15.5544 18.7044C14.0958 19.7315 12.3903 20.3426 10.6172 20.4734C8.84406 20.6043 7.06881 20.2501 5.478 19.448C3.88719 18.646 2.53958 17.4257 1.5768 15.9155C0.614012 14.4053 0.0716171 12.6609 0.00661659 10.8656C-0.058382 9.07036 0.356415 7.29057 1.20741 5.71329C2.05841 4.13602 3.31417 2.81951 4.84273 1.90215C6.37128 0.984779 8.11617 0.500428 9.894 0.5Z",
        fill: color
      }
    )
  );
};
var circle_line_arrow_right_icon_default = CircleLineArrowRightIcon;

// src/icons/shine-star-icon.tsx
import * as React50 from "react";
var ShineStarIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React50.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React50.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React50.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React50.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.36523 2.31004C2.67259 2.542 3.10862 2.47932 3.33914 2.17004C3.56966 1.86076 3.50737 1.422 3.20001 1.19004L1.80871 0.140041C1.50135 -0.0919184 1.06531 -0.0292383 0.834793 0.280041C0.604275 0.589321 0.666565 1.02808 0.973924 1.26004L2.36523 2.31004ZM13.1757 5.53952C13.0777 5.27696 12.8268 5.10252 12.546 5.10169H9.81987C9.72479 5.10175 9.64004 5.04193 9.60848 4.95247L8.62991 2.18563C8.49997 1.83896 8.11291 1.663 7.76539 1.79262C7.58324 1.86057 7.43953 2.00392 7.37142 2.18563L7.36919 2.19278L6.39285 4.95247C6.36134 5.04177 6.27682 5.10156 6.18191 5.10169H3.4549C3.08388 5.10141 2.78289 5.40122 2.78261 5.77133C2.78246 5.97007 2.87074 6.15863 3.02361 6.28607L5.34531 8.20717C5.41639 8.26601 5.44396 8.36236 5.41473 8.44976L4.43929 11.3676C4.32197 11.7187 4.51219 12.0982 4.86417 12.2153C5.07087 12.284 5.29814 12.2485 5.47385 12.12L7.8681 10.3686C7.94689 10.3111 8.054 10.3111 8.13278 10.3686L10.5261 12.1195C10.8249 12.3389 11.2455 12.2751 11.4654 11.9771C11.5949 11.8016 11.6307 11.5743 11.5616 11.3676L10.5862 8.44798C10.5569 8.36057 10.5845 8.26423 10.6556 8.20539L12.9817 6.2816C13.1959 6.09923 13.2733 5.80298 13.1757 5.53952ZM0.00500533 13.3838C-0.024723 13.1355 0.0794456 12.8901 0.278272 12.74L1.66958 11.69C1.97693 11.4581 2.41297 11.5208 2.64349 11.83C2.87401 12.1393 2.81172 12.5781 2.50436 12.81L1.11305 13.86C0.914228 14.0101 0.650951 14.042 0.422397 13.9438C0.193842 13.8455 0.0347336 13.6321 0.00500533 13.3838ZM13.2174 2.45004C13.368 2.45035 13.5145 2.40119 13.6348 2.31004L15.0261 1.26004C15.2249 1.10999 15.3291 0.864601 15.2994 0.61631C15.2696 0.36802 15.1105 0.154549 14.882 0.0563105C14.6534 -0.0419283 14.3901 -0.0100104 14.1913 0.140041L12.8 1.19004C12.5605 1.37082 12.4628 1.68556 12.5574 1.9714C12.6521 2.25724 12.918 2.45004 13.2174 2.45004ZM13.3565 11.83C13.5871 11.5208 14.0231 11.4581 14.3304 11.69L15.7218 12.74C15.9206 12.8901 16.0247 13.1355 15.995 13.3838C15.9653 13.6321 15.8062 13.8455 15.5776 13.9438C15.3491 14.042 15.0858 14.0101 14.887 13.86L13.4957 12.81C13.1883 12.5781 13.126 12.1393 13.3565 11.83Z",
        fill: color
      }
    )
  );
};
var shine_star_icon_default = ShineStarIcon;

// src/icons/drag-indicator-icon.tsx
import * as React51 from "react";
var DragIndicatorIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React51.createElement(
    "svg",
    __spreadValues({
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      color,
      viewBox: "0 0 24 24",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React51.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React51.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React51.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
    /* @__PURE__ */ React51.createElement(
      "path",
      {
        d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
        fill: color
      }
    )
  );
};
var drag_indicator_icon_default = DragIndicatorIcon;

// src/icons/update-heart-beat-icon.tsx
import * as React52 from "react";
var UpdateHeartBeatIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React52.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React52.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React52.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React52.createElement(
      "path",
      {
        d: "M9.67676 6.30493C9.96226 6.15275 10.2883 6.09196 10.6094 6.13208C10.9243 6.17456 11.2194 6.30985 11.458 6.51978C11.6966 6.72979 11.868 7.0057 11.9502 7.31274L12.9209 10.7766C12.9347 10.8272 12.9644 10.8722 13.0049 10.9055C13.0453 10.9388 13.0952 10.9593 13.1475 10.9631C13.1996 10.9671 13.2518 10.9544 13.2969 10.928C13.3418 10.9016 13.3775 10.862 13.3994 10.8147L14.3838 8.65161C14.4991 8.38531 14.6864 8.15631 14.9238 7.9895C15.1612 7.82276 15.4399 7.72443 15.7295 7.7063C16.0191 7.6882 16.3081 7.75107 16.5645 7.88696C16.8208 8.02292 17.0351 8.22691 17.1826 8.47681L18.4922 10.634C18.5618 10.7488 18.6084 10.8764 18.6289 11.009C18.6494 11.1418 18.6432 11.2779 18.6113 11.4084C18.5794 11.5389 18.5217 11.6615 18.4424 11.7698C18.363 11.8781 18.2633 11.9706 18.1484 12.0403C18.0337 12.1099 17.9061 12.1555 17.7734 12.176C17.6406 12.1965 17.5045 12.1913 17.374 12.1594C17.2437 12.1275 17.121 12.0698 17.0127 11.9905C16.9045 11.9112 16.8128 11.8112 16.7432 11.6965L16.1387 10.6995C16.1145 10.6598 16.0792 10.6273 16.0381 10.6057C15.9971 10.5843 15.9505 10.5747 15.9043 10.5774C15.8582 10.5802 15.8136 10.5953 15.7754 10.6213C15.7371 10.6476 15.7068 10.6845 15.6875 10.7268L14.4531 13.4358C14.3277 13.7158 14.1248 13.9541 13.8682 14.1223C13.6115 14.2906 13.3118 14.3817 13.0049 14.385C12.9586 14.3855 12.9123 14.3837 12.8662 14.3792C12.541 14.3471 12.2331 14.2162 11.9844 14.0042C11.7357 13.792 11.5576 13.5088 11.4746 13.1926L10.458 9.56372C10.4442 9.5147 10.4158 9.47065 10.377 9.43774C10.338 9.40483 10.2899 9.38367 10.2393 9.37817C10.1888 9.37274 10.1377 9.38285 10.0928 9.40649C10.0477 9.43027 10.0104 9.46708 9.98633 9.51196L9.34863 10.7063C9.21565 10.9641 9.0148 11.1805 8.76758 11.3323C8.52017 11.4841 8.23559 11.5659 7.94531 11.5676H2.02246C1.75142 11.5675 1.49151 11.4594 1.2998 11.2678C1.10797 11.076 1 10.8155 1 10.5442C1.00003 10.2729 1.108 10.0124 1.2998 9.82056C1.4915 9.62903 1.75148 9.52185 2.02246 9.52173H7.66113L9.01465 6.98267C9.16022 6.69393 9.39147 6.45713 9.67676 6.30493Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React52.createElement(
      "path",
      {
        d: "M12.4629 1.00024C14.1515 1.05346 15.8046 1.4991 17.291 2.302C18.7775 3.10497 20.057 4.24311 21.0273 5.62622C21.9976 7.00928 22.6318 8.59978 22.8809 10.2708C23.1299 11.9418 22.9867 13.6482 22.4619 15.2542C21.9371 16.8601 21.0452 18.3221 19.8574 19.5237C18.6698 20.7251 17.2188 21.6337 15.6191 22.177C14.0193 22.7203 12.3145 22.8833 10.6406 22.6536C8.96682 22.4238 7.36981 21.807 5.97559 20.8528C5.88907 20.7945 5.78592 20.7644 5.68164 20.7659C5.57752 20.7675 5.47627 20.8009 5.3916 20.8616L3.4375 22.2834C3.32234 22.3668 3.18577 22.4162 3.04395 22.426C2.90213 22.4358 2.7603 22.4058 2.63477 22.3391C2.50935 22.2724 2.40518 22.172 2.33398 22.0491C2.26281 21.9262 2.22688 21.7858 2.23145 21.6438L2.42871 16.1711C2.43292 16.0547 2.46422 15.9407 2.51953 15.8381C2.57487 15.7356 2.65303 15.6468 2.74805 15.5793C2.84301 15.512 2.95241 15.4679 3.06738 15.4495C3.18251 15.4311 3.30073 15.4394 3.41211 15.4739L8.55273 17.0627C8.68729 17.1043 8.80768 17.1823 8.90039 17.2883C8.99312 17.3944 9.05486 17.5244 9.07812 17.6633C9.10131 17.8022 9.08532 17.9451 9.03223 18.0754C8.97913 18.2057 8.89084 18.3185 8.77734 18.4016L8.06934 18.9163C8.00047 18.9683 7.94538 19.0367 7.91016 19.1155C7.875 19.1942 7.86008 19.2806 7.86719 19.3665C7.87435 19.4525 7.90341 19.5358 7.95117 19.6077C7.99889 19.6794 8.06425 19.7377 8.14062 19.7776C9.32439 20.3765 10.6278 20.7021 11.9541 20.7297C13.2806 20.7573 14.597 20.486 15.8047 19.9368C17.0123 19.3875 18.0807 18.5737 18.9316 17.5559C19.7827 16.5381 20.394 15.3418 20.7207 14.0559C21.0473 12.7702 21.0813 11.4276 20.8193 10.1272C20.5573 8.82658 20.0062 7.60133 19.207 6.54224C18.4079 5.48316 17.3809 4.61695 16.2021 4.00806C15.0234 3.39925 13.7226 3.06341 12.3965 3.02466C12.2637 3.02068 12.1328 2.99038 12.0117 2.93579C11.8905 2.88114 11.7814 2.80232 11.6904 2.70532C11.5995 2.60837 11.5282 2.49476 11.4814 2.37036C11.4347 2.24599 11.4134 2.1135 11.418 1.98071C11.4222 1.84777 11.452 1.71617 11.5068 1.59497C11.5616 1.47384 11.6403 1.36463 11.7373 1.27368C11.8342 1.18284 11.948 1.11159 12.0723 1.0647C12.1967 1.01778 12.3299 0.995954 12.4629 1.00024ZM4.05371 4.96313C4.18606 4.94313 4.32133 4.9492 4.45117 4.98169C4.58105 5.01421 4.70321 5.07256 4.81055 5.15259C4.91788 5.23261 5.00794 5.3333 5.07617 5.44849C5.14438 5.56364 5.18939 5.69095 5.20801 5.82349C5.22662 5.95608 5.21846 6.09142 5.18457 6.22095C5.15066 6.35034 5.09183 6.47198 5.01074 6.57837C4.73113 6.9552 4.483 7.35436 4.26855 7.77173C4.14488 8.01046 3.93103 8.19027 3.6748 8.27173C3.41856 8.35308 3.14013 8.32986 2.90137 8.2063C2.66263 8.08263 2.48282 7.86877 2.40137 7.61255C2.32 7.35627 2.3432 7.07789 2.4668 6.83911C2.73299 6.32454 3.04058 5.83201 3.38672 5.36743C3.46553 5.25936 3.56537 5.16831 3.67969 5.09888C3.79409 5.02946 3.92141 4.98317 4.05371 4.96313ZM8.70312 1.53638C8.91916 1.46547 9.15269 1.46995 9.36621 1.5481C9.57965 1.62622 9.76066 1.77354 9.87988 1.96704C9.92185 2.03462 9.95577 2.10724 9.98047 2.18286C10.0219 2.30897 10.0383 2.4421 10.0283 2.57446C10.0183 2.70696 9.98183 2.83674 9.92188 2.95532C9.86194 3.07379 9.7794 3.17933 9.67871 3.26587C9.57794 3.35247 9.46121 3.41876 9.33496 3.46021C8.88929 3.60776 8.45635 3.79108 8.04004 4.00806C7.80146 4.12858 7.52438 4.15018 7.26953 4.06958C7.0149 3.98891 6.80159 3.81206 6.67578 3.57642C6.55217 3.33869 6.52798 3.06149 6.6084 2.80591C6.68898 2.55022 6.86778 2.33613 7.10547 2.21216C7.61882 1.94428 8.15345 1.71843 8.70312 1.53638Z",
        fill: color
      }
    )
  );
};
var update_heart_beat_icon_default = UpdateHeartBeatIcon;

// src/icons/update-check-icon.tsx
import * as React53 from "react";
var UpdateCheckIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ React53.createElement(
    "svg",
    __spreadValues({
      width: ((_a2 = props.style) == null ? void 0 : _a2.width) || sizeInPixels,
      height: ((_b2 = props.style) == null ? void 0 : _b2.height) || sizeInPixels,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-labelledby": titleId,
      "aria-describedby": descriptionId
    }, props),
    description ? /* @__PURE__ */ React53.createElement("desc", { id: descriptionId }, description) : null,
    title ? /* @__PURE__ */ React53.createElement("title", { id: titleId }, title) : null,
    /* @__PURE__ */ React53.createElement(
      "path",
      {
        d: "M11.96 6.55138L7.432 11.1837C7.12 11.5029 6.616 11.5029 6.304 11.1837L4.04 8.86754C3.728 8.54835 3.728 8.03274 4.04 7.71355C4.352 7.39436 4.856 7.39436 5.168 7.71355L6.864 9.44862L10.824 5.39739C11.136 5.0782 11.64 5.0782 11.952 5.39739C12.272 5.71658 12.272 6.23219 11.96 6.55138ZM1.6 8C1.6 6.09305 2.416 4.38253 3.696 3.18762L4.92 4.43982C5.168 4.69354 5.6 4.51348 5.6 4.14519V0.634114C5.6 0.404953 5.424 0.224898 5.2 0.224898H1.768C1.408 0.224898 1.232 0.666851 1.488 0.920565L2.56 2.02545C0.992 3.51499 0 5.63473 0 8C0 11.8876 2.656 15.1449 6.208 15.9797C6.712 16.0943 7.2 15.7096 7.2 15.1776C7.2 14.793 6.936 14.4656 6.568 14.3756C3.728 13.7127 1.6 11.11 1.6 8ZM16 8C16 4.11245 13.344 0.85509 9.792 0.0202898C9.288 -0.0942906 8.8 0.290372 8.8 0.822353C8.8 1.20702 9.064 1.53439 9.432 1.62442C12.272 2.28735 14.4 4.88996 14.4 8C14.4 9.90695 13.584 11.6175 12.304 12.8124L11.08 11.5602C10.832 11.3065 10.4 11.4865 10.4 11.8548V15.3659C10.4 15.595 10.576 15.7751 10.8 15.7751H14.232C14.592 15.7751 14.768 15.3331 14.512 15.0794L13.44 13.9746C15.008 12.485 16 10.3653 16 8Z",
        fill: color
      }
    )
  );
};
var update_check_icon_default = UpdateCheckIcon;

// src/icons/icon-component.tsx
var iconNames = {
  arrowLineLeft: "arrow-line-left",
  arrowLineRight: "arrow-line-right",
  arrowRight: "arrow-right",
  assign: "assign",
  bell: "bell",
  bot: "bot",
  building: "building",
  calendar: "calendar",
  check: "check",
  circleArrowRight: "circle-arrow-right",
  circleCheck: "circle-check",
  circleExclamation: "circle-exclamation",
  circleInformation: "circle-information",
  circleLineArrowRight: "circle-line-arrow-right",
  circleLineCheck: "circle-line-check",
  circleDash: "circle-dash",
  circleClock: "circle-clock",
  circleForbidden: "circle-forbidden",
  circleCheckNoBackground: "circle-check-no-background",
  circlePlus: "circle-plus",
  circleUser: "circle-user",
  circleX: "circle-x",
  clipboard: "clipboard",
  close: "close",
  cog: "cog",
  cogDataReport: "cog-data-report",
  downloadDataGrid: "download-data-grid",
  dragIndicator: "drag-indicator",
  emptyListScan: "empty-list-scan",
  emptyListSearch: "empty-list-search",
  list: "list",
  location: "location",
  logout: "logout",
  mailReply: "mail-reply",
  menu: "menu",
  messageAlert: "message-alert",
  minus: "minus",
  monitorHeartBeatSearch: "monitor-heart-beat-search",
  pencil: "pencil",
  pie: "pie",
  play: "play",
  plus: "plus",
  qrCode: "qr-code",
  search: "search",
  settings: "settings",
  shineStar: "shine-star",
  start: "start",
  trailer: "trailer",
  trashLine: "trash-line",
  unassign: "unassign",
  updateCheck: "update-check",
  updateHeartBeat: "update-heart-beat",
  van: "van"
};
var iconElements = {
  [iconNames.arrowLineLeft]: /* @__PURE__ */ React54.createElement(arrow_line_left_icon_default, null),
  [iconNames.arrowLineRight]: /* @__PURE__ */ React54.createElement(arrow_line_right_icon_default, null),
  [iconNames.arrowRight]: /* @__PURE__ */ React54.createElement(arrow_right_icon_default, null),
  [iconNames.assign]: /* @__PURE__ */ React54.createElement(assign_icon_default, null),
  [iconNames.bell]: /* @__PURE__ */ React54.createElement(bell_icon_default, null),
  [iconNames.bot]: /* @__PURE__ */ React54.createElement(bot_icon_default, null),
  [iconNames.building]: /* @__PURE__ */ React54.createElement(building_icon_default, null),
  [iconNames.calendar]: /* @__PURE__ */ React54.createElement(calendar_icon_default, null),
  [iconNames.check]: /* @__PURE__ */ React54.createElement(check_icon_default, null),
  [iconNames.circleArrowRight]: /* @__PURE__ */ React54.createElement(circle_arrow_right_icon_default, null),
  [iconNames.circleCheck]: /* @__PURE__ */ React54.createElement(circle_check_icon_default, null),
  [iconNames.circleExclamation]: /* @__PURE__ */ React54.createElement(circle_exclamation_icon_default, null),
  [iconNames.circleInformation]: /* @__PURE__ */ React54.createElement(circle_information_icon_default, null),
  [iconNames.circleLineArrowRight]: /* @__PURE__ */ React54.createElement(circle_line_arrow_right_icon_default, null),
  [iconNames.circleLineCheck]: /* @__PURE__ */ React54.createElement(circle_line_check_icon_default, null),
  [iconNames.circleDash]: /* @__PURE__ */ React54.createElement(circle_dash_icon_default, null),
  [iconNames.circleClock]: /* @__PURE__ */ React54.createElement(circle_clock_icon_default, null),
  [iconNames.circleForbidden]: /* @__PURE__ */ React54.createElement(circle_forbidden_icon_default, null),
  [iconNames.circleCheckNoBackground]: /* @__PURE__ */ React54.createElement(circle_check_no_background_icon_default, null),
  [iconNames.circlePlus]: /* @__PURE__ */ React54.createElement(circle_plus_icon_default, null),
  [iconNames.circleUser]: /* @__PURE__ */ React54.createElement(circle_user_icon_default, null),
  [iconNames.circleX]: /* @__PURE__ */ React54.createElement(circle_x_icon_default, null),
  [iconNames.clipboard]: /* @__PURE__ */ React54.createElement(circle_clipboard_icon_default, null),
  [iconNames.close]: /* @__PURE__ */ React54.createElement(close_icon_default, null),
  [iconNames.cogDataReport]: /* @__PURE__ */ React54.createElement(cog_data_report_icon_default, null),
  [iconNames.cog]: /* @__PURE__ */ React54.createElement(cog_icon_default, null),
  [iconNames.downloadDataGrid]: /* @__PURE__ */ React54.createElement(download_data_grid_icon_default, null),
  [iconNames.dragIndicator]: /* @__PURE__ */ React54.createElement(drag_indicator_icon_default, null),
  [iconNames.emptyListScan]: /* @__PURE__ */ React54.createElement(empty_list_scan_icon_default, null),
  [iconNames.emptyListSearch]: /* @__PURE__ */ React54.createElement(empty_list_search_icon_default, null),
  [iconNames.list]: /* @__PURE__ */ React54.createElement(list_icon_default, null),
  [iconNames.location]: /* @__PURE__ */ React54.createElement(location_icon_default, null),
  [iconNames.logout]: /* @__PURE__ */ React54.createElement(logout_icon_default, null),
  [iconNames.mailReply]: /* @__PURE__ */ React54.createElement(mail_reply_icon_default, null),
  [iconNames.menu]: /* @__PURE__ */ React54.createElement(menu_icon_default, null),
  [iconNames.messageAlert]: /* @__PURE__ */ React54.createElement(message_alert_icon_default, null),
  [iconNames.minus]: /* @__PURE__ */ React54.createElement(minus_icon_default, null),
  [iconNames.monitorHeartBeatSearch]: /* @__PURE__ */ React54.createElement(monitor_heart_beat_search_icon_default, null),
  [iconNames.pencil]: /* @__PURE__ */ React54.createElement(pencil_icon_default, null),
  [iconNames.pie]: /* @__PURE__ */ React54.createElement(pie_icon_default, null),
  [iconNames.play]: /* @__PURE__ */ React54.createElement(play_icon_default, null),
  [iconNames.plus]: /* @__PURE__ */ React54.createElement(plus_icon_default, null),
  [iconNames.qrCode]: /* @__PURE__ */ React54.createElement(qr_code_icon_default, null),
  [iconNames.search]: /* @__PURE__ */ React54.createElement(search_icon_default, null),
  [iconNames.settings]: /* @__PURE__ */ React54.createElement(settings_icon_default, null),
  [iconNames.shineStar]: /* @__PURE__ */ React54.createElement(shine_star_icon_default, null),
  [iconNames.start]: /* @__PURE__ */ React54.createElement(star_icon_default, null),
  [iconNames.trailer]: /* @__PURE__ */ React54.createElement(vehicle_type_trailer_icon_default, null),
  [iconNames.trashLine]: /* @__PURE__ */ React54.createElement(trash_line_icon_default, null),
  [iconNames.unassign]: /* @__PURE__ */ React54.createElement(unassign_icon_default, null),
  [iconNames.updateCheck]: /* @__PURE__ */ React54.createElement(update_check_icon_default, null),
  [iconNames.updateHeartBeat]: /* @__PURE__ */ React54.createElement(update_heart_beat_icon_default, null),
  [iconNames.van]: /* @__PURE__ */ React54.createElement(vehicle_type_van_icon_default, null)
};
var iconColors = {
  primary: "primary",
  secondary: "secondary",
  grey: "grey"
};
var iconSizes = {
  xl: "xl",
  l: "l",
  m: "m",
  s: "s",
  xs: "xs",
  xxs: "2xs"
};
function IconComponent(_a) {
  var _b = _a, {
    name,
    color = "#000",
    colorVariant,
    sizeInPixels = 16,
    size
  } = _b, props = __objRest(_b, [
    "name",
    "color",
    "colorVariant",
    "sizeInPixels",
    "size"
  ]);
  let colorValue = color;
  let sizeValue;
  if (colorVariant) {
    switch (colorVariant) {
      case iconColors.primary:
        colorValue = "var(--otk-ui-icon-primary-color, #39a0df)";
        break;
      case iconColors.secondary:
        colorValue = "var(--otk-ui-icon-secondary-color, #e6b800)";
        break;
      case iconColors.grey:
        colorValue = "var(--otk-ui-icon-grey-color, #94A6B8)";
        break;
    }
  }
  if (size) {
    switch (size) {
      case iconSizes.xl:
        sizeValue = "var(--otk-ui-icon-xl-size, 24px)";
        break;
      case iconSizes.l:
        sizeValue = "var(--otk-ui-icon-l-size, 20px)";
        break;
      case iconSizes.m:
        sizeValue = "var(--otk-ui-icon-m-size, 16px)";
        break;
      case iconSizes.s:
        sizeValue = "var(--otk-ui-icon-s-size, 12px)";
        break;
      case iconSizes.xs:
        sizeValue = "var(--otk-ui-icon-xs-size, 8px)";
        break;
      case iconSizes.xxs:
        sizeValue = "var(--otk-ui-icon-2xs-size, 6px)";
        break;
    }
  }
  return cloneElement(iconElements[name], __spreadValues({
    color: colorValue,
    sizeInPixels,
    style: {
      width: sizeValue,
      height: sizeValue
    }
  }, props));
}

// src/icons/ticket-alerts-icon.tsx
import * as React55 from "react";
var TicketAlertsIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React55.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React55.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React55.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React55.createElement(
      "path",
      {
        d: "M16 6V4H12V0H10V4H6V0H4V4H0V6H4V10H0V12H4V16H6V12H10V16H12V12H16V10H12V6H16ZM10 10H6V6H10V10Z",
        fill: color
      }
    )
  );
};
var ticket_alerts_icon_default = TicketAlertsIcon;

// src/icons/quote-alerts-icon.tsx
import * as React56 from "react";
var QuoteAlertsIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React56.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React56.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React56.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React56.createElement("g", { clipPath: "url(#clip0_1196_7816)" }, /* @__PURE__ */ React56.createElement(
      "path",
      {
        d: "M13.6667 1.33332H10.3334C10.3052 1.3332 10.2776 1.32569 10.2533 1.31153C10.2289 1.29737 10.2087 1.27707 10.1947 1.25265C9.96903 0.871085 9.64783 0.554903 9.26275 0.335268C8.87768 0.115632 8.44202 0.00012207 7.99871 0.00012207C7.5554 0.00012207 7.11974 0.115632 6.73466 0.335268C6.34958 0.554903 6.02838 0.871085 5.80271 1.25265C5.78892 1.27668 5.76915 1.29674 5.74532 1.31088C5.72149 1.32501 5.69441 1.33274 5.66671 1.33332H2.33337C2.06816 1.33332 1.8138 1.43868 1.62627 1.62621C1.43873 1.81375 1.33337 2.0681 1.33337 2.33332V15C1.33337 15.2652 1.43873 15.5196 1.62627 15.7071C1.8138 15.8946 2.06816 16 2.33337 16H13.6667C13.9319 16 14.1863 15.8946 14.3738 15.7071C14.5613 15.5196 14.6667 15.2652 14.6667 15V2.33332C14.6667 2.0681 14.5613 1.81375 14.3738 1.62621C14.1863 1.43868 13.9319 1.33332 13.6667 1.33332ZM12.6667 10.84C12.6669 11.2375 12.525 11.6219 12.2667 11.924L10.9874 13.4173C10.8308 13.6 10.6365 13.7466 10.4178 13.8471C10.1992 13.9476 9.96134 13.9995 9.72071 13.9993H3.66671C3.5783 13.9993 3.49352 13.9642 3.43101 13.9017C3.36849 13.8392 3.33337 13.7544 3.33337 13.666V3.66665C3.33337 3.57825 3.36849 3.49346 3.43101 3.43095C3.49352 3.36844 3.5783 3.33332 3.66671 3.33332H12.3334C12.4218 3.33332 12.5066 3.36844 12.5691 3.43095C12.6316 3.49346 12.6667 3.57825 12.6667 3.66665V10.84Z",
        fill: color
      }
    ), /* @__PURE__ */ React56.createElement(
      "path",
      {
        d: "M10.6667 5.49933H5.33337C5.20077 5.49933 5.07359 5.55201 4.97982 5.64578C4.88605 5.73954 4.83337 5.86672 4.83337 5.99933C4.83337 6.13194 4.88605 6.25911 4.97982 6.35288C5.07359 6.44665 5.20077 6.49933 5.33337 6.49933H10.6667C10.7993 6.49933 10.9265 6.44665 11.0203 6.35288C11.114 6.25911 11.1667 6.13194 11.1667 5.99933C11.1667 5.86672 11.114 5.73954 11.0203 5.64578C10.9265 5.55201 10.7993 5.49933 10.6667 5.49933Z",
        fill: color
      }
    ), /* @__PURE__ */ React56.createElement(
      "path",
      {
        d: "M10.6667 7.83264H5.33337C5.20077 7.83264 5.07359 7.88532 4.97982 7.97909C4.88605 8.07286 4.83337 8.20003 4.83337 8.33264C4.83337 8.46525 4.88605 8.59243 4.97982 8.6862C5.07359 8.77996 5.20077 8.83264 5.33337 8.83264H10.6667C10.7993 8.83264 10.9265 8.77996 11.0203 8.6862C11.114 8.59243 11.1667 8.46525 11.1667 8.33264C11.1667 8.20003 11.114 8.07286 11.0203 7.97909C10.9265 7.88532 10.7993 7.83264 10.6667 7.83264Z",
        fill: color
      }
    ), /* @__PURE__ */ React56.createElement(
      "path",
      {
        d: "M8.33337 10.166H5.33337C5.20077 10.166 5.07359 10.2187 4.97982 10.3125C4.88605 10.4062 4.83337 10.5334 4.83337 10.666C4.83337 10.7986 4.88605 10.9258 4.97982 11.0196C5.07359 11.1133 5.20077 11.166 5.33337 11.166H8.33337C8.46598 11.166 8.59316 11.1133 8.68693 11.0196C8.7807 10.9258 8.83337 10.7986 8.83337 10.666C8.83337 10.5334 8.7807 10.4062 8.68693 10.3125C8.59316 10.2187 8.46598 10.166 8.33337 10.166Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React56.createElement("defs", null, /* @__PURE__ */ React56.createElement("clipPath", { id: "clip0_1196_7816" }, /* @__PURE__ */ React56.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var quote_alerts_icon_default = QuoteAlertsIcon;

// src/icons/offer-alerts-icon.tsx
import * as React57 from "react";
var OfferAlertsIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 20,
    color = "#000"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React57.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React57.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React57.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React57.createElement("g", { clipPath: "url(#clip0_304_42865)" }, /* @__PURE__ */ React57.createElement(
      "path",
      {
        d: "M20 10C20 8.02219 19.4135 6.08879 18.3147 4.4443C17.2159 2.79981 15.6541 1.51809 13.8268 0.761209C11.9996 0.00433251 9.98891 -0.193701 8.0491 0.192151C6.10929 0.578003 4.32746 1.53041 2.92893 2.92894C1.53041 4.32746 0.577999 6.10929 0.192146 8.0491C-0.193705 9.98891 0.00432725 11.9996 0.761203 13.8268C1.51808 15.6541 2.7998 17.2159 4.4443 18.3147C6.08879 19.4135 8.02219 20 10 20C12.6513 19.9971 15.1932 18.9426 17.0679 17.0679C18.9426 15.1932 19.9971 12.6513 20 10ZM1.66667 10C1.66667 8.35183 2.15541 6.74066 3.07109 5.37025C3.98676 3.99984 5.28825 2.93174 6.81097 2.30101C8.33369 1.67028 10.0092 1.50525 11.6258 1.82679C13.2423 2.14834 14.7271 2.94201 15.8926 4.10745C17.058 5.27289 17.8517 6.75774 18.1732 8.37425C18.4948 9.99076 18.3297 11.6663 17.699 13.189C17.0683 14.7118 16.0002 16.0132 14.6298 16.9289C13.2593 17.8446 11.6482 18.3333 10 18.3333C7.79061 18.3309 5.6724 17.4522 4.11012 15.8899C2.54785 14.3276 1.66909 12.2094 1.66667 10Z",
        fill: color
      }
    ), /* @__PURE__ */ React57.createElement(
      "path",
      {
        d: "M16.6667 9.99998C16.6667 9.88947 16.6228 9.78349 16.5447 9.70535C16.4666 9.62721 16.3606 9.58331 16.2501 9.58331L10.4167 9.58331L10.4167 3.74998C10.4167 3.63947 10.3728 3.53349 10.2947 3.45535C10.2166 3.37721 10.1106 3.33331 10.0001 3.33331C8.68154 3.33331 7.39261 3.72431 6.29628 4.45685C5.19995 5.18939 4.34547 6.23058 3.84088 7.44876C3.3363 8.66693 3.20428 10.0074 3.46151 11.3006C3.71875 12.5938 4.35369 13.7817 5.28604 14.714C6.21839 15.6464 7.40627 16.2813 8.69948 16.5385C9.99269 16.7958 11.3331 16.6638 12.5513 16.1592C13.7695 15.6546 14.8107 14.8001 15.5432 13.7038C16.2758 12.6075 16.6667 11.3185 16.6667 9.99998Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React57.createElement("defs", null, /* @__PURE__ */ React57.createElement("clipPath", { id: "clip0_304_42865" }, /* @__PURE__ */ React57.createElement("rect", { width: "20", height: "20", fill: "white", transform: "translate(20) rotate(90)" })))
  );
};
var offer_alerts_icon_default = OfferAlertsIcon;

// src/icons/user-management-icon.tsx
import * as React58 from "react";
var UserManagementIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#94A6B8"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React58.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React58.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React58.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React58.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3333 0H1.66667C1.22464 0 0.800716 0.175595 0.488155 0.488155C0.175595 0.800716 0 1.22464 0 1.66667V14.3333C0 14.5522 0.0431096 14.7689 0.126867 14.9711C0.210625 15.1733 0.333391 15.3571 0.488155 15.5118C0.64292 15.6666 0.826652 15.7894 1.02886 15.8731C1.23107 15.9569 1.4478 16 1.66667 16H14.3333C14.5522 16 14.7689 15.9569 14.9711 15.8731C15.1733 15.7894 15.3571 15.6666 15.5118 15.5118C15.6666 15.3571 15.7894 15.1733 15.8731 14.9711C15.9569 14.7689 16 14.5522 16 14.3333V1.66667C16 1.4478 15.9569 1.23107 15.8731 1.02886C15.7894 0.826652 15.6666 0.64292 15.5118 0.488155C15.3571 0.333391 15.1733 0.210625 14.9711 0.126867C14.7689 0.0431096 14.5522 0 14.3333 0ZM9.37966 5.875C9.37973 6.35936 9.26619 6.83698 9.04816 7.2695C9.02487 7.31686 9.01717 7.37037 9.02615 7.42237C9.03513 7.47437 9.06034 7.5222 9.09816 7.559C9.53715 7.99943 10.1328 8.24791 10.7547 8.25C11.3845 8.25 11.9886 7.99978 12.434 7.55438C12.8794 7.10898 13.1297 6.50489 13.1297 5.875C13.1297 5.24511 12.8794 4.64102 12.434 4.19562C11.9886 3.75022 11.3845 3.5 10.7547 3.5C10.1319 3.50143 9.53526 3.74996 9.09566 4.191C9.05784 4.2278 9.03263 4.27563 9.02365 4.32763C9.01467 4.37963 9.02237 4.43314 9.04566 4.4805C9.26455 4.9128 9.37895 5.39044 9.37966 5.875ZM9.56084 8.6965C9.94361 8.56651 10.3451 8.50014 10.7493 8.5C11.7436 8.50106 12.6968 8.89649 13.3998 9.59952C14.1029 10.3026 14.4983 11.2558 14.4993 12.25C14.4993 12.3163 14.473 12.3799 14.4261 12.4268C14.3792 12.4737 14.3156 12.5 14.2493 12.5H10.9993C10.933 12.5 10.8694 12.4737 10.8226 12.4268C10.7757 12.3799 10.7493 12.3163 10.7493 12.25C10.749 11.0741 10.2862 9.94557 9.46084 9.108C9.43133 9.07767 9.40999 9.04035 9.39884 8.99953C9.38769 8.95871 9.38708 8.91572 9.39707 8.8746C9.40706 8.83348 9.42733 8.79557 9.45597 8.76442C9.48462 8.73327 9.5207 8.7099 9.56084 8.6965ZM5.75 8.25C7.06168 8.25 8.125 7.18668 8.125 5.875C8.125 4.56332 7.06168 3.5 5.75 3.5C4.43832 3.5 3.375 4.56332 3.375 5.875C3.375 7.18668 4.43832 8.25 5.75 8.25ZM8.40165 9.59835C9.10491 10.3016 9.5 11.2554 9.5 12.25C9.5 12.3163 9.47366 12.3799 9.42678 12.4268C9.37989 12.4737 9.3163 12.5 9.25 12.5H2.25C2.1837 12.5 2.12011 12.4737 2.07322 12.4268C2.02634 12.3799 2 12.3163 2 12.25C2 11.2554 2.39509 10.3016 3.09835 9.59835C3.80161 8.89509 4.75544 8.5 5.75 8.5C6.74456 8.5 7.69839 8.89509 8.40165 9.59835Z",
        fill: color
      }
    )
  );
};
var user_management_icon_default = UserManagementIcon;

// src/icons/content-modules-icon.tsx
import * as React59 from "react";
var ContentModulesIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#94A6B8"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React59.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React59.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React59.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React59.createElement("g", { clipPath: "url(#clip0_3392_16481)" }, /* @__PURE__ */ React59.createElement(
      "path",
      {
        d: "M6.33333 -0.00195312H1C0.447715 -0.00195312 0 0.445762 0 0.998047V6.33138C0 6.88367 0.447715 7.33138 1 7.33138H6.33333C6.88562 7.33138 7.33333 6.88367 7.33333 6.33138V0.998047C7.33333 0.445762 6.88562 -0.00195312 6.33333 -0.00195312Z",
        fill: color
      }
    ), /* @__PURE__ */ React59.createElement(
      "path",
      {
        d: "M15 -0.00195312H9.66663C9.11434 -0.00195312 8.66663 0.445762 8.66663 0.998047V6.33138C8.66663 6.88367 9.11434 7.33138 9.66663 7.33138H15C15.5522 7.33138 16 6.88367 16 6.33138V0.998047C16 0.445762 15.5522 -0.00195312 15 -0.00195312Z",
        fill: color
      }
    ), /* @__PURE__ */ React59.createElement(
      "path",
      {
        d: "M6.33333 8.66467H1C0.447715 8.66467 0 9.11239 0 9.66467V14.998C0 15.5503 0.447715 15.998 1 15.998H6.33333C6.88562 15.998 7.33333 15.5503 7.33333 14.998V9.66467C7.33333 9.11239 6.88562 8.66467 6.33333 8.66467Z",
        fill: color
      }
    ), /* @__PURE__ */ React59.createElement(
      "path",
      {
        d: "M15 8.66467H9.66663C9.11434 8.66467 8.66663 9.11239 8.66663 9.66467V14.998C8.66663 15.5503 9.11434 15.998 9.66663 15.998H15C15.5522 15.998 16 15.5503 16 14.998V9.66467C16 9.11239 15.5522 8.66467 15 8.66467Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React59.createElement("defs", null, /* @__PURE__ */ React59.createElement("clipPath", { id: "clip0_3392_16481" }, /* @__PURE__ */ React59.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var content_modules_icon_default = ContentModulesIcon;

// src/icons/other-actions-icon.tsx
import * as React60 from "react";
var OtherActionsIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 16,
    color = "#94A6B8"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React60.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React60.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React60.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React60.createElement("g", { clipPath: "url(#clip0_3392_16466)" }, /* @__PURE__ */ React60.createElement(
      "path",
      {
        d: "M14.3333 0H1.66667C1.22464 0 0.800716 0.175595 0.488155 0.488155C0.175595 0.800716 0 1.22464 0 1.66667L0 14.3333C0 14.5522 0.0431096 14.7689 0.126867 14.9711C0.210625 15.1733 0.333391 15.3571 0.488155 15.5118C0.64292 15.6666 0.826652 15.7894 1.02886 15.8731C1.23107 15.9569 1.4478 16 1.66667 16H14.3333C14.5522 16 14.7689 15.9569 14.9711 15.8731C15.1733 15.7894 15.3571 15.6666 15.5118 15.5118C15.6666 15.3571 15.7894 15.1733 15.8731 14.9711C15.9569 14.7689 16 14.5522 16 14.3333V1.66667C16 1.4478 15.9569 1.23107 15.8731 1.02886C15.7894 0.826652 15.6666 0.64292 15.5118 0.488155C15.3571 0.333391 15.1733 0.210625 14.9711 0.126867C14.7689 0.0431096 14.5522 0 14.3333 0ZM12.3333 6.33333H9.33333C9.15652 6.33333 8.98695 6.2631 8.86193 6.13807C8.73691 6.01305 8.66667 5.84348 8.66667 5.66667C8.66667 5.48986 8.73691 5.32029 8.86193 5.19526C8.98695 5.07024 9.15652 5 9.33333 5H12.3333C12.5101 5 12.6797 5.07024 12.8047 5.19526C12.9298 5.32029 13 5.48986 13 5.66667C13 5.84348 12.9298 6.01305 12.8047 6.13807C12.6797 6.2631 12.5101 6.33333 12.3333 6.33333ZM13 11.6667C13 11.8435 12.9298 12.013 12.8047 12.1381C12.6797 12.2631 12.5101 12.3333 12.3333 12.3333H9.33333C9.15652 12.3333 8.98695 12.2631 8.86193 12.1381C8.73691 12.013 8.66667 11.8435 8.66667 11.6667C8.66667 11.4899 8.73691 11.3203 8.86193 11.1953C8.98695 11.0702 9.15652 11 9.33333 11H12.3333C12.5101 11 12.6797 11.0702 12.8047 11.1953C12.9298 11.3203 13 11.4899 13 11.6667ZM7.53333 3.73333L5.53333 6.4C5.4762 6.47671 5.40322 6.54023 5.31937 6.58624C5.23551 6.63226 5.14273 6.65968 5.04733 6.66667H5C4.8232 6.66663 4.65366 6.59637 4.52867 6.47133L3.52867 5.47133C3.40357 5.34633 3.33326 5.17675 3.3332 4.9999C3.33314 4.82306 3.40333 4.65343 3.52833 4.52833C3.65334 4.40324 3.82292 4.33293 3.99976 4.33287C4.17661 4.3328 4.34624 4.40299 4.47133 4.528L4.928 4.98467L6.46667 2.93333C6.57275 2.79188 6.73069 2.69837 6.90572 2.67337C7.08075 2.64836 7.25855 2.69391 7.4 2.8C7.54145 2.90609 7.63496 3.06402 7.65997 3.23905C7.68497 3.41409 7.63942 3.59188 7.53333 3.73333ZM7.53333 10.4L5.53333 13.0667C5.47485 13.1414 5.40134 13.2031 5.31754 13.2477C5.23374 13.2923 5.14153 13.3188 5.04684 13.3255C4.95216 13.3322 4.85713 13.319 4.76787 13.2867C4.67861 13.2544 4.59713 13.2038 4.52867 13.138L3.52867 12.138C3.40723 12.0123 3.34003 11.8439 3.34155 11.6691C3.34307 11.4943 3.41318 11.3271 3.53679 11.2035C3.66039 11.0798 3.8276 11.0097 4.0024 11.0082C4.1772 11.0067 4.3456 11.0739 4.47133 11.1953L4.928 11.652L6.46667 9.6C6.57275 9.45855 6.73069 9.36504 6.90572 9.34003C7.08075 9.31503 7.25855 9.36058 7.4 9.46667C7.54145 9.57275 7.63496 9.73069 7.65997 9.90572C7.68497 10.0808 7.63942 10.2586 7.53333 10.4Z",
        fill: color
      }
    )),
    /* @__PURE__ */ React60.createElement("defs", null, /* @__PURE__ */ React60.createElement("clipPath", { id: "clip0_3392_16466" }, /* @__PURE__ */ React60.createElement("rect", { width: "16", height: "16", fill: "white" })))
  );
};
var other_actions_icon_default = OtherActionsIcon;

// src/icons/manual-assign-flag-icon.tsx
import * as React61 from "react";
var ManualAssignFlagIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 24,
    heightInPixels = 8,
    color = "#2396DC"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React61.createElement(
    "svg",
    __spreadValues({
      width: widthInPixels,
      height: heightInPixels,
      viewBox: "0 0 24 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React61.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React61.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React61.createElement("rect", { width: "24", height: "8", fill: color }),
    /* @__PURE__ */ React61.createElement("rect", { x: "7", y: "3", width: "10", height: "2", rx: "1", fill: "white" })
  );
};
var manual_assign_flag_icon_default = ManualAssignFlagIcon;

// src/icons/vertical-menu-icon.tsx
import * as React62 from "react";
var VerticalMenuIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    sizeInPixels = 18,
    color = "#94A6B8"
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "sizeInPixels",
    "color"
  ]);
  return /* @__PURE__ */ React62.createElement(
    "svg",
    __spreadValues({
      width: sizeInPixels,
      height: sizeInPixels,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React62.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React62.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React62.createElement(
      "path",
      {
        d: "M9 4.875C10.3462 4.875 11.4375 3.78369 11.4375 2.4375C11.4375 1.09131 10.3462 0 9 0C7.65381 0 6.5625 1.09131 6.5625 2.4375C6.5625 3.78369 7.65381 4.875 9 4.875Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React62.createElement(
      "path",
      {
        d: "M9 11.4375C10.3462 11.4375 11.4375 10.3462 11.4375 9C11.4375 7.65381 10.3462 6.5625 9 6.5625C7.65381 6.5625 6.5625 7.65381 6.5625 9C6.5625 10.3462 7.65381 11.4375 9 11.4375Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React62.createElement(
      "path",
      {
        d: "M9 18C10.3462 18 11.4375 16.9087 11.4375 15.5625C11.4375 14.2163 10.3462 13.125 9 13.125C7.65381 13.125 6.5625 14.2163 6.5625 15.5625C6.5625 16.9087 7.65381 18 9 18Z",
        fill: color
      }
    )
  );
};
var vertical_menu_icon_default = VerticalMenuIcon;

// src/icons/poland-flag-icon.tsx
import * as React63 from "react";
var PolandFlagIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 24,
    heightInPixels = 4
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels"
  ]);
  return /* @__PURE__ */ React63.createElement(
    "svg",
    __spreadValues({
      width: widthInPixels,
      height: heightInPixels,
      viewBox: "0 0 24 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React63.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React63.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React63.createElement("rect", { width: "24", height: "2", fill: "white" }),
    /* @__PURE__ */ React63.createElement("rect", { y: "2", width: "24", height: "2", fill: "#DC143C" })
  );
};
var poland_flag_icon_default = PolandFlagIcon;

// src/icons/spain-flag-icon.tsx
import * as React64 from "react";
var SpainFlagIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 24,
    heightInPixels = 4
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels"
  ]);
  return /* @__PURE__ */ React64.createElement(
    "svg",
    __spreadValues({
      width: widthInPixels,
      height: heightInPixels,
      viewBox: "0 0 24 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React64.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React64.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React64.createElement("rect", { width: "24", height: "1.2", fill: "#C70B1F" }),
    /* @__PURE__ */ React64.createElement("rect", { y: "1.19995", width: "24", height: "1.6", fill: "#FFC403" }),
    /* @__PURE__ */ React64.createElement("rect", { y: "2.80005", width: "24", height: "1.2", fill: "#C70B1F" })
  );
};
var spain_flag_icon_default = SpainFlagIcon;

// src/icons/romania-flag-icon.tsx
import * as React65 from "react";
var RomaniaFlagIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 24,
    heightInPixels = 4
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels"
  ]);
  return /* @__PURE__ */ React65.createElement(
    "svg",
    __spreadValues({
      width: widthInPixels,
      height: heightInPixels,
      viewBox: "0 0 24 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React65.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React65.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React65.createElement("rect", { width: "8", height: "4", fill: "#012B7F" }),
    /* @__PURE__ */ React65.createElement("rect", { x: "8", width: "8", height: "4", fill: "#FCD116" }),
    /* @__PURE__ */ React65.createElement("rect", { x: "16", width: "8", height: "4", fill: "#CE1226" })
  );
};
var romania_flag_icon_default = RomaniaFlagIcon;

// src/icons/france-flag-icon.tsx
import * as React66 from "react";
var FranceFlagIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    description,
    descriptionId,
    widthInPixels = 24,
    heightInPixels = 4
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "description",
    "descriptionId",
    "widthInPixels",
    "heightInPixels"
  ]);
  return /* @__PURE__ */ React66.createElement(
    "svg",
    __spreadValues({
      width: widthInPixels,
      height: heightInPixels,
      viewBox: "0 0 24 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-labelledby": titleId
    }, props),
    title ? /* @__PURE__ */ React66.createElement("title", { id: titleId }, title) : null,
    description ? /* @__PURE__ */ React66.createElement("desc", { id: descriptionId }, description) : null,
    /* @__PURE__ */ React66.createElement("rect", { width: "8", height: "4", fill: "#002395" }),
    /* @__PURE__ */ React66.createElement("rect", { x: "8", width: "8", height: "4", fill: "white" }),
    /* @__PURE__ */ React66.createElement("rect", { x: "16", width: "8", height: "4", fill: "#ED2939" })
  );
};
var france_flag_icon_default = FranceFlagIcon;
export {
  arrow_line_left_icon_default as ArrowLineLeftIcon,
  arrow_line_right_icon_default as ArrowLineRightIcon,
  arrow_right_icon_default as ArrowRightIcon,
  assign_icon_default as AssignIcon,
  calendar_icon_default as CalendarIcon,
  circle_arrow_right_icon_default as CircleArrowRightIcon,
  circle_check_icon_default as CircleCheckIcon,
  circle_check_no_background_icon_default as CircleCheckNoBackgroundIcon,
  circle_clock_icon_default as CircleClockIcon,
  circle_dash_icon_default as CircleDashIcon,
  circle_exclamation_icon_default as CircleExclamationIcon,
  circle_forbidden_icon_default as CircleForbiddenIcon,
  circle_information_icon_default as CircleInformationIcon,
  circle_line_arrow_right_icon_default as CircleLineArrowRightIcon,
  circle_line_check_icon_default as CircleLineCheckIcon,
  circle_plus_icon_default as CirclePlusIcon,
  circle_user_icon_default as CircleUserIcon,
  circle_x_icon_default as CircleXIcon,
  circle_clipboard_icon_default as ClipboardIcon,
  close_icon_default as CloseIcon,
  cog_icon_default as CogIcon,
  content_modules_icon_default as ContentModulesIcon,
  empty_list_scan_icon_default as EmptyListScanIcon,
  empty_list_search_icon_default as EmptyListSearchIcon,
  france_flag_icon_default as FranceFlagIcon,
  IconComponent,
  list_icon_default as ListIcon,
  location_icon_default as LocationIcon,
  mail_reply_icon_default as MailReplyIcon,
  manual_assign_flag_icon_default as ManualAssignFlagIcon,
  offer_alerts_icon_default as OfferAlertsIcon,
  other_actions_icon_default as OtherActionsIcon,
  poland_flag_icon_default as PolandFlagIcon,
  qr_code_icon_default as QrCodeIcon,
  quote_alerts_icon_default as QuoteAlertsIcon,
  romania_flag_icon_default as RomaniaFlagIcon,
  search_icon_default as SearchIcon,
  spain_flag_icon_default as SpainFlagIcon,
  star_icon_default as StarIcon,
  ticket_alerts_icon_default as TicketAlertsIcon,
  trash_line_icon_default as TrashLineIcon,
  unassign_icon_default as UnassignIcon,
  user_management_icon_default as UserManagementIcon,
  vehicle_type_trailer_icon_default as VehicleTypeTrailerIcon,
  vehicle_type_van_icon_default as VehicleTypeVanIcon,
  vertical_menu_icon_default as VerticalMenuIcon,
  iconColors,
  iconNames
};
